const Datamap = [
  {
    "State": "AL",
    "County": "Baldwin County",
    "NumberofStores": 189
  },
  {
    "State": "AL",
    "County": "Mobile County",
    "NumberofStores": 361
  },
  {
    "State": "AZ",
    "County": "Apache County",
    "NumberofStores": 28
  },
  {
    "State": "AZ",
    "County": "Cochise County",
    "NumberofStores": 119
  },
  {
    "State": "AZ",
    "County": "Coconino County",
    "NumberofStores": 124
  },
  {
    "State": "AZ",
    "County": "Gila County",
    "NumberofStores": 67
  },
  {
    "State": "AZ",
    "County": "Graham County",
    "NumberofStores": 31
  },
  {
    "State": "AZ",
    "County": "Greenlee County",
    "NumberofStores": 8
  },
  {
    "State": "AZ",
    "County": "La Paz County",
    "NumberofStores": 17
  },
  {
    "State": "AZ",
    "County": "Maricopa County",
    "NumberofStores": 1348
  },
  {
    "State": "AZ",
    "County": "Mohave County",
    "NumberofStores": 171
  },
  {
    "State": "AZ",
    "County": "Navajo County",
    "NumberofStores": 76
  },
  {
    "State": "AZ",
    "County": "Pima County",
    "NumberofStores": 984
  },
  {
    "State": "AZ",
    "County": "Pinal County",
    "NumberofStores": 332
  },
  {
    "State": "AZ",
    "County": "Santa Cruz County",
    "NumberofStores": 39
  },
  {
    "State": "AZ",
    "County": "Yavapai County",
    "NumberofStores": 166
  },
  {
    "State": "AZ",
    "County": "Yuma County",
    "NumberofStores": 158
  },
  {
    "State": "CA",
    "County": "Alameda",
    "NumberofStores": 782
  },
  {
    "State": "CA",
    "County": "Alpine",
    "NumberofStores": 6
  },
  {
    "State": "CA",
    "County": "Amador",
    "NumberofStores": 41
  },
  {
    "State": "CA",
    "County": "Butte",
    "NumberofStores": 214
  },
  {
    "State": "CA",
    "County": "Calaveras",
    "NumberofStores": 47
  },
  {
    "State": "CA",
    "County": "Colusa",
    "NumberofStores": 29
  },
  {
    "State": "CA",
    "County": "Contra Costa",
    "NumberofStores": 563
  },
  {
    "State": "CA",
    "County": "Del Norte",
    "NumberofStores": 33
  },
  {
    "State": "CA",
    "County": "El Dorado",
    "NumberofStores": 131
  },
  {
    "State": "CA",
    "County": "Fresno",
    "NumberofStores": 647
  },
  {
    "State": "CA",
    "County": "Glenn",
    "NumberofStores": 34
  },
  {
    "State": "CA",
    "County": "Humboldt",
    "NumberofStores": 117
  },
  {
    "State": "CA",
    "County": "Imperial",
    "NumberofStores": 96
  },
  {
    "State": "CA",
    "County": "Kern",
    "NumberofStores": 512
  },
  {
    "State": "CA",
    "County": "Kings",
    "NumberofStores": 113
  },
  {
    "State": "CA",
    "County": "Lake",
    "NumberofStores": 38
  },
  {
    "State": "CA",
    "County": "Los Angeles",
    "NumberofStores": 2413
  },
  {
    "State": "CA",
    "County": "Madera",
    "NumberofStores": 97
  },
  {
    "State": "CA",
    "County": "Marin",
    "NumberofStores": 143
  },
  {
    "State": "CA",
    "County": "Mariposa",
    "NumberofStores": 21
  },
  {
    "State": "CA",
    "County": "Mendocino",
    "NumberofStores": 87
  },
  {
    "State": "CA",
    "County": "Merced",
    "NumberofStores": 169
  },
  {
    "State": "CA",
    "County": "Monterey",
    "NumberofStores": 183
  },
  {
    "State": "CA",
    "County": "Napa",
    "NumberofStores": 94
  },
  {
    "State": "CA",
    "County": "Nevada",
    "NumberofStores": 127
  },
  {
    "State": "CA",
    "County": "Orange",
    "NumberofStores": 1837
  },
  {
    "State": "CA",
    "County": "Placer",
    "NumberofStores": 263
  },
  {
    "State": "CA",
    "County": "Riverside",
    "NumberofStores": 987
  },
  {
    "State": "CA",
    "County": "Sacramento",
    "NumberofStores": 471
  },
  {
    "State": "CA",
    "County": "San Benito",
    "NumberofStores": 31
  },
  {
    "State": "CA",
    "County": "San Bernardino",
    "NumberofStores": 1129
  },
  {
    "State": "CA",
    "County": "San Diego",
    "NumberofStores": 1473
  },
  {
    "State": "CA",
    "County": "San Francisco",
    "NumberofStores": 683
  },
  {
    "State": "CA",
    "County": "San Joaquin",
    "NumberofStores": 347
  },
  {
    "State": "CA",
    "County": "San Luis Obispo",
    "NumberofStores": 167
  },
  {
    "State": "CA",
    "County": "San Mateo",
    "NumberofStores": 389
  },
  {
    "State": "CA",
    "County": "Santa Barbara",
    "NumberofStores": 214
  },
  {
    "State": "CA",
    "County": "Santa Clara",
    "NumberofStores": 1327
  },
  {
    "State": "CA",
    "County": "Santa Cruz",
    "NumberofStores": 193
  },
  {
    "State": "CA",
    "County": "Shasta",
    "NumberofStores": 121
  },
  {
    "State": "CA",
    "County": "Siskiyou",
    "NumberofStores": 39
  },
  {
    "State": "CA",
    "County": "Solano",
    "NumberofStores": 283
  },
  {
    "State": "CA",
    "County": "Sonoma",
    "NumberofStores": 317
  },
  {
    "State": "CA",
    "County": "Stanislaus",
    "NumberofStores": 247
  },
  {
    "State": "CA",
    "County": "Sutter",
    "NumberofStores": 83
  },
  {
    "State": "CA",
    "County": "Tehama",
    "NumberofStores": 61
  },
  {
    "State": "CA",
    "County": "Trinity",
    "NumberofStores": 14
  },
  {
    "State": "CA",
    "County": "Tulare",
    "NumberofStores": 523
  },
  {
    "State": "CA",
    "County": "Tuolumne",
    "NumberofStores": 73
  },
  {
    "State": "CA",
    "County": "Ventura",
    "NumberofStores": 387
  },
  {
    "State": "CA",
    "County": "Yolo",
    "NumberofStores": 139
  },
  {
    "State": "CA",
    "County": "Yuba",
    "NumberofStores": 84
  },
  {
    "State": "CO",
    "County": "Adams",
    "NumberofStores": 621
  },
  {
    "State": "CO",
    "County": "Alamosa",
    "NumberofStores": 29
  },
  {
    "State": "CO",
    "County": "Arapahoe",
    "NumberofStores": 847
  },
  {
    "State": "CO",
    "County": "Baca",
    "NumberofStores": 7
  },
  {
    "State": "CO",
    "County": "Bent",
    "NumberofStores": 21
  },
  {
    "State": "CO",
    "County": "Boulder",
    "NumberofStores": 413
  },
  {
    "State": "CO",
    "County": "Broomfield",
    "NumberofStores": 127
  },
  {
    "State": "CO",
    "County": "Cheyenne",
    "NumberofStores": 9
  },
  {
    "State": "CO",
    "County": "Clear Creek",
    "NumberofStores": 33
  },
  {
    "State": "CO",
    "County": "Conejos",
    "NumberofStores": 27
  },
  {
    "State": "CO",
    "County": "Costilla",
    "NumberofStores": 19
  },
  {
    "State": "CO",
    "County": "Crowley",
    "NumberofStores": 11
  },
  {
    "State": "CO",
    "County": "Custer",
    "NumberofStores": 17
  },
  {
    "State": "CO",
    "County": "Denver",
    "NumberofStores": 937
  },
  {
    "State": "CO",
    "County": "Douglas",
    "NumberofStores": 423
  },
  {
    "State": "CO",
    "County": "El Paso",
    "NumberofStores": 1139
  },
  {
    "State": "CO",
    "County": "Elbert",
    "NumberofStores": 61
  },
  {
    "State": "CO",
    "County": "Fremont",
    "NumberofStores": 137
  },
  {
    "State": "CO",
    "County": "Gilpin",
    "NumberofStores": 13
  },
  {
    "State": "CO",
    "County": "Huerfano",
    "NumberofStores": 23
  },
  {
    "State": "CO",
    "County": "Jefferson",
    "NumberofStores": 697
  },
  {
    "State": "CO",
    "County": "Kiowa",
    "NumberofStores": 6
  },
  {
    "State": "CO",
    "County": "Kit Carson",
    "NumberofStores": 19
  },
  {
    "State": "CO",
    "County": "Las Animas",
    "NumberofStores": 47
  },
  {
    "State": "CO",
    "County": "Lincoln",
    "NumberofStores": 21
  },
  {
    "State": "CO",
    "County": "Otero",
    "NumberofStores": 53
  },
  {
    "State": "CO",
    "County": "Prowers",
    "NumberofStores": 41
  },
  {
    "State": "CO",
    "County": "Pueblo",
    "NumberofStores": 317
  },
  {
    "State": "CO",
    "County": "Saguache",
    "NumberofStores": 29
  },
  {
    "State": "CO",
    "County": "Teller",
    "NumberofStores": 83
  },
  {
    "State": "FL",
    "County": "Baker County",
    "NumberofStores": 19
  },
  {
    "State": "FL",
    "County": "Brevard",
    "NumberofStores": 463
  },
  {
    "State": "FL",
    "County": "Broward",
    "NumberofStores": 1437
  },
  {
    "State": "FL",
    "County": "Charlotte",
    "NumberofStores": 181
  },
  {
    "State": "FL",
    "County": "Citrus",
    "NumberofStores": 109
  },
  {
    "State": "FL",
    "County": "Clay",
    "NumberofStores": 167
  },
  {
    "State": "FL",
    "County": "Collier",
    "NumberofStores": 237
  },
  {
    "State": "FL",
    "County": "Desoto",
    "NumberofStores": 21
  },
  {
    "State": "FL",
    "County": "Duval",
    "NumberofStores": 742
  },
  {
    "State": "FL",
    "County": "Flagler",
    "NumberofStores": 97
  },
  {
    "State": "FL",
    "County": "Glades",
    "NumberofStores": 11
  },
  {
    "State": "FL",
    "County": "Hardee",
    "NumberofStores": 19
  },
  {
    "State": "FL",
    "County": "Hendry",
    "NumberofStores": 29
  },
  {
    "State": "FL",
    "County": "Hernando",
    "NumberofStores": 141
  },
  {
    "State": "FL",
    "County": "Highlands",
    "NumberofStores": 123
  },
  {
    "State": "FL",
    "County": "Hillsborough",
    "NumberofStores": 823
  },
  {
    "State": "FL",
    "County": "Indian River",
    "NumberofStores": 167
  },
  {
    "State": "FL",
    "County": "Lake",
    "NumberofStores": 287
  },
  {
    "State": "FL",
    "County": "Lee",
    "NumberofStores": 451
  },
  {
    "State": "FL",
    "County": "Manatee",
    "NumberofStores": 239
  },
  {
    "State": "FL",
    "County": "Martin",
    "NumberofStores": 139
  },
  {
    "State": "FL",
    "County": "Miami-Dade",
    "NumberofStores": 1849
  },
  {
    "State": "FL",
    "County": "Monroe",
    "NumberofStores": 79
  },
  {
    "State": "FL",
    "County": "Nassau County",
    "NumberofStores": 113
  },
  {
    "State": "FL",
    "County": "Okeechobee",
    "NumberofStores": 33
  },
  {
    "State": "FL",
    "County": "Orange",
    "NumberofStores": 987
  },
  {
    "State": "FL",
    "County": "Osceola",
    "NumberofStores": 341
  },
  {
    "State": "FL",
    "County": "Palm Beach",
    "NumberofStores": 913
  },
  {
    "State": "FL",
    "County": "Pasco",
    "NumberofStores": 389
  },
  {
    "State": "FL",
    "County": "Pinellas",
    "NumberofStores": 847
  },
  {
    "State": "FL",
    "County": "Polk",
    "NumberofStores": 693
  },
  {
    "State": "FL",
    "County": "Putnam",
    "NumberofStores": 73
  },
  {
    "State": "FL",
    "County": "Sarasota",
    "NumberofStores": 283
  },
  {
    "State": "FL",
    "County": "Seminole",
    "NumberofStores": 317
  },
  {
    "State": "FL",
    "County": "St. Johns",
    "NumberofStores": 223
  },
  {
    "State": "FL",
    "County": "St. Lucie",
    "NumberofStores": 293
  },
  {
    "State": "FL",
    "County": "Volusia",
    "NumberofStores": 437
  },
  {
    "State": "GA",
    "County": "Banks",
    "NumberofStores": 21
  },
  {
    "State": "GA",
    "County": "Barrow",
    "NumberofStores": 137
  },
  {
    "State": "GA",
    "County": "Bartow",
    "NumberofStores": 213
  },
  {
    "State": "GA",
    "County": "Camden County",
    "NumberofStores": 119
  },
  {
    "State": "GA",
    "County": "Catoosa",
    "NumberofStores": 103
  },
  {
    "State": "GA",
    "County": "Charlton County",
    "NumberofStores": 29
  },
  {
    "State": "GA",
    "County": "Chattooga",
    "NumberofStores": 61
  },
  {
    "State": "GA",
    "County": "Cherokee",
    "NumberofStores": 317
  },
  {
    "State": "GA",
    "County": "Clarke",
    "NumberofStores": 167
  },
  {
    "State": "GA",
    "County": "Clayton",
    "NumberofStores": 289
  },
  {
    "State": "GA",
    "County": "Cobb",
    "NumberofStores": 847
  },
  {
    "State": "GA",
    "County": "Dade",
    "NumberofStores": 23
  },
  {
    "State": "GA",
    "County": "Dawson",
    "NumberofStores": 57
  },
  {
    "State": "GA",
    "County": "DeKalb",
    "NumberofStores": 783
  },
  {
    "State": "GA",
    "County": "Douglas",
    "NumberofStores": 193
  },
  {
    "State": "GA",
    "County": "Elbert",
    "NumberofStores": 41
  },
  {
    "State": "GA",
    "County": "Fannin",
    "NumberofStores": 33
  },
  {
    "State": "GA",
    "County": "Floyd",
    "NumberofStores": 143
  },
  {
    "State": "GA",
    "County": "Forsyth",
    "NumberofStores": 263
  },
  {
    "State": "GA",
    "County": "Fulton",
    "NumberofStores": 1217
  },
  {
    "State": "GA",
    "County": "Gilmer",
    "NumberofStores": 39
  },
  {
    "State": "GA",
    "County": "Gordon",
    "NumberofStores": 117
  },
  {
    "State": "GA",
    "County": "Gwinnett",
    "NumberofStores": 913
  },
  {
    "State": "GA",
    "County": "Hall",
    "NumberofStores": 247
  },
  {
    "State": "GA",
    "County": "Henry",
    "NumberofStores": 389
  },
  {
    "State": "GA",
    "County": "Jackson",
    "NumberofStores": 127
  },
  {
    "State": "GA",
    "County": "Lumpkin",
    "NumberofStores": 49
  },
  {
    "State": "GA",
    "County": "Madison",
    "NumberofStores": 53
  },
  {
    "State": "GA",
    "County": "Morgan",
    "NumberofStores": 61
  },
  {
    "State": "GA",
    "County": "Murray",
    "NumberofStores": 83
  },
  {
    "State": "GA",
    "County": "Newton",
    "NumberofStores": 193
  },
  {
    "State": "GA",
    "County": "Oconee",
    "NumberofStores": 47
  },
  {
    "State": "GA",
    "County": "Oglethorpe",
    "NumberofStores": 31
  },
  {
    "State": "GA",
    "County": "Paulding",
    "NumberofStores": 327
  },
  {
    "State": "GA",
    "County": "Pickens",
    "NumberofStores": 71
  },
  {
    "State": "GA",
    "County": "Polk",
    "NumberofStores": 137
  },
  {
    "State": "GA",
    "County": "Rockdale",
    "NumberofStores": 129
  },
  {
    "State": "GA",
    "County": "Towns",
    "NumberofStores": 17
  },
  {
    "State": "GA",
    "County": "Union",
    "NumberofStores": 27
  },
  {
    "State": "GA",
    "County": "Walker",
    "NumberofStores": 157
  },
  {
    "State": "GA",
    "County": "Walton",
    "NumberofStores": 173
  },
  {
    "State": "GA",
    "County": "White",
    "NumberofStores": 43
  },
  {
    "State": "GA",
    "County": "Whitfield",
    "NumberofStores": 267
  },
  {
    "State": "IA",
    "County": "Adair",
    "NumberofStores": 17
  },
  {
    "State": "IA",
    "County": "Adams",
    "NumberofStores": 14
  },
  {
    "State": "IA",
    "County": "Allamakee",
    "NumberofStores": 29
  },
  {
    "State": "IA",
    "County": "Appanoose",
    "NumberofStores": 33
  },
  {
    "State": "IA",
    "County": "Audubon",
    "NumberofStores": 21
  },
  {
    "State": "IA",
    "County": "Benton",
    "NumberofStores": 83
  },
  {
    "State": "IA",
    "County": "Black Hawk",
    "NumberofStores": 287
  },
  {
    "State": "IA",
    "County": "Boone",
    "NumberofStores": 79
  },
  {
    "State": "IA",
    "County": "Bremer",
    "NumberofStores": 67
  },
  {
    "State": "IA",
    "County": "Buchanan",
    "NumberofStores": 71
  },
  {
    "State": "IA",
    "County": "Buena Vista",
    "NumberofStores": 53
  },
  {
    "State": "IA",
    "County": "Butler",
    "NumberofStores": 41
  },
  {
    "State": "IA",
    "County": "Calhoun",
    "NumberofStores": 37
  },
  {
    "State": "IA",
    "County": "Carroll",
    "NumberofStores": 63
  },
  {
    "State": "IA",
    "County": "Cass",
    "NumberofStores": 39
  },
  {
    "State": "IA",
    "County": "Cedar",
    "NumberofStores": 57
  },
  {
    "State": "IA",
    "County": "Cerro Gordo",
    "NumberofStores": 97
  },
  {
    "State": "IA",
    "County": "Cherokee",
    "NumberofStores": 47
  },
  {
    "State": "IA",
    "County": "Chickasaw",
    "NumberofStores": 31
  },
  {
    "State": "IA",
    "County": "Clarke",
    "NumberofStores": 29
  },
  {
    "State": "IA",
    "County": "Clay",
    "NumberofStores": 59
  },
  {
    "State": "IA",
    "County": "Clayton",
    "NumberofStores": 43
  },
  {
    "State": "IA",
    "County": "Clinton",
    "NumberofStores": 173
  },
  {
    "State": "IA",
    "County": "Crawford",
    "NumberofStores": 61
  },
  {
    "State": "IA",
    "County": "Dallas",
    "NumberofStores": 197
  },
  {
    "State": "IA",
    "County": "Davis",
    "NumberofStores": 23
  },
  {
    "State": "IA",
    "County": "Decatur",
    "NumberofStores": 19
  },
  {
    "State": "IA",
    "County": "Delaware",
    "NumberofStores": 67
  },
  {
    "State": "IA",
    "County": "Des Moines",
    "NumberofStores": 211
  },
  {
    "State": "IA",
    "County": "Dickinson",
    "NumberofStores": 73
  },
  {
    "State": "IA",
    "County": "Dubuque",
    "NumberofStores": 183
  },
  {
    "State": "IA",
    "County": "Emmet",
    "NumberofStores": 49
  },
  {
    "State": "IA",
    "County": "Fayette",
    "NumberofStores": 71
  },
  {
    "State": "IA",
    "County": "Floyd",
    "NumberofStores": 57
  },
  {
    "State": "IA",
    "County": "Franklin",
    "NumberofStores": 41
  },
  {
    "State": "IA",
    "County": "Fremont",
    "NumberofStores": 19
  },
  {
    "State": "IA",
    "County": "Greene",
    "NumberofStores": 37
  },
  {
    "State": "IA",
    "County": "Grundy",
    "NumberofStores": 33
  },
  {
    "State": "IA",
    "County": "Guthrie",
    "NumberofStores": 39
  },
  {
    "State": "IA",
    "County": "Hamilton",
    "NumberofStores": 71
  },
  {
    "State": "IA",
    "County": "Hancock",
    "NumberofStores": 43
  },
  {
    "State": "IA",
    "County": "Hardin",
    "NumberofStores": 67
  },
  {
    "State": "IA",
    "County": "Harrison",
    "NumberofStores": 73
  },
  {
    "State": "IA",
    "County": "Henry",
    "NumberofStores": 83
  },
  {
    "State": "IA",
    "County": "Howard",
    "NumberofStores": 31
  },
  {
    "State": "IA",
    "County": "Humboldt",
    "NumberofStores": 29
  },
  {
    "State": "IA",
    "County": "Ida",
    "NumberofStores": 27
  },
  {
    "State": "IA",
    "County": "Iowa",
    "NumberofStores": 23
  },
  {
    "State": "IA",
    "County": "Jackson",
    "NumberofStores": 47
  },
  {
    "State": "IA",
    "County": "Jasper",
    "NumberofStores": 97
  },
  {
    "State": "IA",
    "County": "Jefferson",
    "NumberofStores": 79
  },
  {
    "State": "IA",
    "County": "Johnson",
    "NumberofStores": 53
  },
  {
    "State": "IA",
    "County": "Jones",
    "NumberofStores": 297
  },
  {
    "State": "IA",
    "County": "Keokuk",
    "NumberofStores": 89
  },
  {
    "State": "IA",
    "County": "Kossuth",
    "NumberofStores": 41
  },
  {
    "State": "IA",
    "County": "Lee",
    "NumberofStores": 113
  },
  {
    "State": "IA",
    "County": "Linn",
    "NumberofStores": 193
  },
  {
    "State": "IA",
    "County": "Louisa",
    "NumberofStores": 387
  },
  {
    "State": "IA",
    "County": "Lucas",
    "NumberofStores": 57
  },
  {
    "State": "IA",
    "County": "Lyon",
    "NumberofStores": 33
  },
  {
    "State": "IA",
    "County": "Madison",
    "NumberofStores": 31
  },
  {
    "State": "IA",
    "County": "Mahaska",
    "NumberofStores": 47
  },
  {
    "State": "IA",
    "County": "Marion",
    "NumberofStores": 63
  },
  {
    "State": "IA",
    "County": "Marshall",
    "NumberofStores": 59
  },
  {
    "State": "IA",
    "County": "Mills",
    "NumberofStores": 79
  },
  {
    "State": "IA",
    "County": "Mitchell",
    "NumberofStores": 43
  },
  {
    "State": "IA",
    "County": "Monona",
    "NumberofStores": 37
  },
  {
    "State": "IA",
    "County": "Monroe",
    "NumberofStores": 29
  },
  {
    "State": "IA",
    "County": "Montgomery",
    "NumberofStores": 27
  },
  {
    "State": "IA",
    "County": "Muscatine",
    "NumberofStores": 51
  },
  {
    "State": "IA",
    "County": "O'Brien",
    "NumberofStores": 83
  },
  {
    "State": "IA",
    "County": "Osceola",
    "NumberofStores": 61
  },
  {
    "State": "IA",
    "County": "Page",
    "NumberofStores": 19
  },
  {
    "State": "IA",
    "County": "Palo Alto",
    "NumberofStores": 29
  },
  {
    "State": "IA",
    "County": "Plymouth",
    "NumberofStores": 73
  },
  {
    "State": "IA",
    "County": "Pocahontas",
    "NumberofStores": 47
  },
  {
    "State": "IA",
    "County": "Polk",
    "NumberofStores": 617
  },
  {
    "State": "IA",
    "County": "Pottawattamie",
    "NumberofStores": 247
  },
  {
    "State": "IA",
    "County": "Poweshiek",
    "NumberofStores": 79
  },
  {
    "State": "IA",
    "County": "Ringgold",
    "NumberofStores": 23
  },
  {
    "State": "IA",
    "County": "Sac",
    "NumberofStores": 41
  },
  {
    "State": "IA",
    "County": "Scott",
    "NumberofStores": 327
  },
  {
    "State": "IA",
    "County": "Shelby",
    "NumberofStores": 67
  },
  {
    "State": "IA",
    "County": "Sioux",
    "NumberofStores": 183
  },
  {
    "State": "IA",
    "County": "Story",
    "NumberofStores": 213
  },
  {
    "State": "IA",
    "County": "Tama",
    "NumberofStores": 59
  },
  {
    "State": "IA",
    "County": "Taylor",
    "NumberofStores": 27
  },
  {
    "State": "IA",
    "County": "Union",
    "NumberofStores": 31
  },
  {
    "State": "IA",
    "County": "Van Buren",
    "NumberofStores": 19
  },
  {
    "State": "IA",
    "County": "Wapello",
    "NumberofStores": 97
  },
  {
    "State": "IA",
    "County": "Warren",
    "NumberofStores": 137
  },
  {
    "State": "IA",
    "County": "Washington",
    "NumberofStores": 83
  },
  {
    "State": "IA",
    "County": "Wayne",
    "NumberofStores": 71
  },
  {
    "State": "IA",
    "County": "Webster",
    "NumberofStores": 29
  },
  {
    "State": "IA",
    "County": "Winnebago",
    "NumberofStores": 117
  },
  {
    "State": "IA",
    "County": "Winneshiek",
    "NumberofStores": 37
  },
  {
    "State": "IA",
    "County": "Woodbury",
    "NumberofStores": 53
  },
  {
    "State": "IA",
    "County": "Worth",
    "NumberofStores": 267
  },
  {
    "State": "IA",
    "County": "Wright",
    "NumberofStores": 21
  },
  {
    "State": "ID",
    "County": "Ada",
    "NumberofStores": 61
  },
  {
    "State": "ID",
    "County": "Adams",
    "NumberofStores": 11
  },
  {
    "State": "ID",
    "County": "Boise",
    "NumberofStores": 163
  },
  {
    "State": "ID",
    "County": "Canyon",
    "NumberofStores": 247
  },
  {
    "State": "ID",
    "County": "Elmore",
    "NumberofStores": 83
  },
  {
    "State": "ID",
    "County": "Gem",
    "NumberofStores": 41
  },
  {
    "State": "ID",
    "County": "Owyhee",
    "NumberofStores": 29
  },
  {
    "State": "ID",
    "County": "Payette",
    "NumberofStores": 67
  },
  {
    "State": "ID",
    "County": "Valley",
    "NumberofStores": 53
  },
  {
    "State": "ID",
    "County": "Washington",
    "NumberofStores": 37
  },
  {
    "State": "IL",
    "County": "Alexander",
    "NumberofStores": 19
  },
  {
    "State": "IL",
    "County": "Boone",
    "NumberofStores": 113
  },
  {
    "State": "IL",
    "County": "Bureau",
    "NumberofStores": 63
  },
  {
    "State": "IL",
    "County": "Calhoun",
    "NumberofStores": 21
  },
  {
    "State": "IL",
    "County": "Carroll",
    "NumberofStores": 29
  },
  {
    "State": "IL",
    "County": "Cass County",
    "NumberofStores": 47
  },
  {
    "State": "IL",
    "County": "Champaign",
    "NumberofStores": 31
  },
  {
    "State": "IL",
    "County": "Christian",
    "NumberofStores": 327
  },
  {
    "State": "IL",
    "County": "Clark",
    "NumberofStores": 83
  },
  {
    "State": "IL",
    "County": "Clay",
    "NumberofStores": 41
  },
  {
    "State": "IL",
    "County": "Cook",
    "NumberofStores": 39
  },
  {
    "State": "IL",
    "County": "Crawford",
    "NumberofStores": 1847
  },
  {
    "State": "IL",
    "County": "De Witt",
    "NumberofStores": 37
  },
  {
    "State": "IL",
    "County": "DeKalb",
    "NumberofStores": 29
  },
  {
    "State": "IL",
    "County": "Douglas",
    "NumberofStores": 117
  },
  {
    "State": "IL",
    "County": "DuPage",
    "NumberofStores": 23
  },
  {
    "State": "IL",
    "County": "Edgar",
    "NumberofStores": 613
  },
  {
    "State": "IL",
    "County": "Edwards",
    "NumberofStores": 41
  },
  {
    "State": "IL",
    "County": "Ford",
    "NumberofStores": 19
  },
  {
    "State": "IL",
    "County": "Franklin",
    "NumberofStores": 33
  },
  {
    "State": "IL",
    "County": "Fulton",
    "NumberofStores": 97
  },
  {
    "State": "IL",
    "County": "Gallatin",
    "NumberofStores": 79
  },
  {
    "State": "IL",
    "County": "Greene County",
    "NumberofStores": 21
  },
  {
    "State": "IL",
    "County": "Grundy",
    "NumberofStores": 57
  },
  {
    "State": "IL",
    "County": "Hamilton",
    "NumberofStores": 73
  },
  {
    "State": "IL",
    "County": "Hardin",
    "NumberofStores": 29
  },
  {
    "State": "IL",
    "County": "Henderson",
    "NumberofStores": 17
  },
  {
    "State": "IL",
    "County": "Henry",
    "NumberofStores": 19
  },
  {
    "State": "IL",
    "County": "Iroquois",
    "NumberofStores": 83
  },
  {
    "State": "IL",
    "County": "Jackson",
    "NumberofStores": 63
  },
  {
    "State": "IL",
    "County": "Jasper",
    "NumberofStores": 117
  },
  {
    "State": "IL",
    "County": "Jersey",
    "NumberofStores": 39
  },
  {
    "State": "IL",
    "County": "Jo Daviess",
    "NumberofStores": 29
  },
  {
    "State": "IL",
    "County": "Johnson",
    "NumberofStores": 31
  },
  {
    "State": "IL",
    "County": "Kane",
    "NumberofStores": 17
  },
  {
    "State": "IL",
    "County": "Kankakee",
    "NumberofStores": 247
  },
  {
    "State": "IL",
    "County": "Kendall",
    "NumberofStores": 137
  },
  {
    "State": "IL",
    "County": "Knox",
    "NumberofStores": 97
  },
  {
    "State": "IL",
    "County": "La Salle",
    "NumberofStores": 73
  },
  {
    "State": "IL",
    "County": "Lake",
    "NumberofStores": 197
  },
  {
    "State": "IL",
    "County": "Lawrence",
    "NumberofStores": 317
  },
  {
    "State": "IL",
    "County": "Lee",
    "NumberofStores": 593
  },
  {
    "State": "IL",
    "County": "Livingston",
    "NumberofStores": 41
  },
  {
    "State": "IL",
    "County": "Logan",
    "NumberofStores": 53
  },
  {
    "State": "IL",
    "County": "Macon",
    "NumberofStores": 61
  },
  {
    "State": "IL",
    "County": "Macoupin",
    "NumberofStores": 47
  },
  {
    "State": "IL",
    "County": "Madison",
    "NumberofStores": 113
  },
  {
    "State": "IL",
    "County": "Marshall",
    "NumberofStores": 167
  },
  {
    "State": "IL",
    "County": "Mason County",
    "NumberofStores": 413
  },
  {
    "State": "IL",
    "County": "Massac",
    "NumberofStores": 31
  },
  {
    "State": "IL",
    "County": "McDonough",
    "NumberofStores": 47
  },
  {
    "State": "IL",
    "County": "McHenry",
    "NumberofStores": 89
  },
  {
    "State": "IL",
    "County": "McLean",
    "NumberofStores": 73
  },
  {
    "State": "IL",
    "County": "Menard",
    "NumberofStores": 61
  },
  {
    "State": "IL",
    "County": "Mercer",
    "NumberofStores": 33
  },
  {
    "State": "IL",
    "County": "Monroe",
    "NumberofStores": 29
  },
  {
    "State": "IL",
    "County": "Montgomery",
    "NumberofStores": 67
  },
  {
    "State": "IL",
    "County": "Morgan County",
    "NumberofStores": 213
  },
  {
    "State": "IL",
    "County": "Moultrie",
    "NumberofStores": 41
  },
  {
    "State": "IL",
    "County": "Ogle",
    "NumberofStores": 27
  },
  {
    "State": "IL",
    "County": "Peoria",
    "NumberofStores": 19
  },
  {
    "State": "IL",
    "County": "Perry",
    "NumberofStores": 23
  },
  {
    "State": "IL",
    "County": "Piatt",
    "NumberofStores": 11
  },
  {
    "State": "IL",
    "County": "Pope",
    "NumberofStores": 17
  },
  {
    "State": "IL",
    "County": "Pulaski",
    "NumberofStores": 57
  },
  {
    "State": "IL",
    "County": "Putnam",
    "NumberofStores": 43
  },
  {
    "State": "IL",
    "County": "Randolph",
    "NumberofStores": 137
  },
  {
    "State": "IL",
    "County": "Richland",
    "NumberofStores": 63
  },
  {
    "State": "IL",
    "County": "Rock Island",
    "NumberofStores": 317
  },
  {
    "State": "IL",
    "County": "Saline",
    "NumberofStores": 29
  },
  {
    "State": "IL",
    "County": "Sangamon",
    "NumberofStores": 23
  },
  {
    "State": "IL",
    "County": "Schuyler County",
    "NumberofStores": 547
  },
  {
    "State": "IL",
    "County": "Scott County",
    "NumberofStores": 21
  },
  {
    "State": "IL",
    "County": "St. Clair",
    "NumberofStores": 83
  },
  {
    "State": "IL",
    "County": "Stark",
    "NumberofStores": 193
  },
  {
    "State": "IL",
    "County": "Stephenson",
    "NumberofStores": 37
  },
  {
    "State": "IL",
    "County": "Tazewell",
    "NumberofStores": 167
  },
  {
    "State": "IL",
    "County": "Union",
    "NumberofStores": 19
  },
  {
    "State": "IL",
    "County": "Vermilion",
    "NumberofStores": 113
  },
  {
    "State": "IL",
    "County": "Wabash",
    "NumberofStores": 21
  },
  {
    "State": "IL",
    "County": "Warren",
    "NumberofStores": 53
  },
  {
    "State": "IL",
    "County": "Wayne",
    "NumberofStores": 29
  },
  {
    "State": "IL",
    "County": "White",
    "NumberofStores": 27
  },
  {
    "State": "IL",
    "County": "Whiteside",
    "NumberofStores": 83
  },
  {
    "State": "IL",
    "County": "Will",
    "NumberofStores": 197
  },
  {
    "State": "IL",
    "County": "Williamson",
    "NumberofStores": 127
  },
  {
    "State": "IL",
    "County": "Winnebago",
    "NumberofStores": 213
  },
  {
    "State": "IL",
    "County": "Woodford",
    "NumberofStores": 47
  },
  {
    "State": "IN",
    "County": "Adams County",
    "NumberofStores": 317
  },
  {
    "State": "IN",
    "County": "Allen County",
    "NumberofStores": 61
  },
  {
    "State": "IN",
    "County": "Bartholomew",
    "NumberofStores": 147
  },
  {
    "State": "IN",
    "County": "Benton",
    "NumberofStores": 21
  },
  {
    "State": "IN",
    "County": "Blackford",
    "NumberofStores": 33
  },
  {
    "State": "IN",
    "County": "Boone",
    "NumberofStores": 167
  },
  {
    "State": "IN",
    "County": "Brown",
    "NumberofStores": 29
  },
  {
    "State": "IN",
    "County": "Carroll",
    "NumberofStores": 41
  },
  {
    "State": "IN",
    "County": "Cass",
    "NumberofStores": 113
  },
  {
    "State": "IN",
    "County": "Clark",
    "NumberofStores": 197
  },
  {
    "State": "IN",
    "County": "Clay",
    "NumberofStores": 61
  },
  {
    "State": "IN",
    "County": "Clinton",
    "NumberofStores": 97
  },
  {
    "State": "IN",
    "County": "Crawford",
    "NumberofStores": 23
  },
  {
    "State": "IN",
    "County": "Daviess",
    "NumberofStores": 83
  },
  {
    "State": "IN",
    "County": "Dearborn",
    "NumberofStores": 127
  },
  {
    "State": "IN",
    "County": "Decatur",
    "NumberofStores": 47
  },
  {
    "State": "IN",
    "County": "DeKalb County",
    "NumberofStores": 193
  },
  {
    "State": "IN",
    "County": "Delaware",
    "NumberofStores": 213
  },
  {
    "State": "IN",
    "County": "Dubois",
    "NumberofStores": 79
  },
  {
    "State": "IN",
    "County": "Elkhart",
    "NumberofStores": 487
  },
  {
    "State": "IN",
    "County": "Fayette",
    "NumberofStores": 37
  },
  {
    "State": "IN",
    "County": "Floyd",
    "NumberofStores": 163
  },
  {
    "State": "IN",
    "County": "Fountain",
    "NumberofStores": 27
  },
  {
    "State": "IN",
    "County": "Franklin",
    "NumberofStores": 53
  },
  {
    "State": "IN",
    "County": "Fulton",
    "NumberofStores": 43
  },
  {
    "State": "IN",
    "County": "Gibson",
    "NumberofStores": 137
  },
  {
    "State": "IN",
    "County": "Grant County",
    "NumberofStores": 317
  },
  {
    "State": "IN",
    "County": "Greene",
    "NumberofStores": 73
  },
  {
    "State": "IN",
    "County": "Hamilton",
    "NumberofStores": 523
  },
  {
    "State": "IN",
    "County": "Hancock",
    "NumberofStores": 247
  },
  {
    "State": "IN",
    "County": "Harrison",
    "NumberofStores": 89
  },
  {
    "State": "IN",
    "County": "Hendricks",
    "NumberofStores": 397
  },
  {
    "State": "IN",
    "County": "Henry",
    "NumberofStores": 183
  },
  {
    "State": "IN",
    "County": "Howard",
    "NumberofStores": 287
  },
  {
    "State": "IN",
    "County": "Huntington County",
    "NumberofStores": 173
  },
  {
    "State": "IN",
    "County": "Jackson",
    "NumberofStores": 117
  },
  {
    "State": "IN",
    "County": "Jasper",
    "NumberofStores": 67
  },
  {
    "State": "IN",
    "County": "Jay",
    "NumberofStores": 41
  },
  {
    "State": "IN",
    "County": "Jefferson",
    "NumberofStores": 113
  },
  {
    "State": "IN",
    "County": "Jennings",
    "NumberofStores": 97
  },
  {
    "State": "IN",
    "County": "Johnson",
    "NumberofStores": 263
  },
  {
    "State": "IN",
    "County": "Knox",
    "NumberofStores": 143
  },
  {
    "State": "IN",
    "County": "Kosciusko",
    "NumberofStores": 187
  },
  {
    "State": "IN",
    "County": "La Porte County",
    "NumberofStores": 327
  },
  {
    "State": "IN",
    "County": "LaGrange County",
    "NumberofStores": 83
  },
  {
    "State": "IN",
    "County": "Lake",
    "NumberofStores": 697
  },
  {
    "State": "IN",
    "County": "LaPorte",
    "NumberofStores": 697
  },
  {
    "State": "IN",
    "County": "Lawrence",
    "NumberofStores": 117
  },
  {
    "State": "IN",
    "County": "Madison",
    "NumberofStores": 417
  },
  {
    "State": "IN",
    "County": "Marion",
    "NumberofStores": 1127
  },
  {
    "State": "IN",
    "County": "Marshall",
    "NumberofStores": 173
  },
  {
    "State": "IN",
    "County": "Martin",
    "NumberofStores": 39
  },
  {
    "State": "IN",
    "County": "Miami",
    "NumberofStores": 71
  },
  {
    "State": "IN",
    "County": "Monroe",
    "NumberofStores": 213
  },
  {
    "State": "IN",
    "County": "Montgomery",
    "NumberofStores": 73
  },
  {
    "State": "IN",
    "County": "Morgan",
    "NumberofStores": 127
  },
  {
    "State": "IN",
    "County": "Newton",
    "NumberofStores": 29
  },
  {
    "State": "IN",
    "County": "Noble County",
    "NumberofStores": 83
  },
  {
    "State": "IN",
    "County": "Ohio",
    "NumberofStores": 7
  },
  {
    "State": "IN",
    "County": "Orange",
    "NumberofStores": 43
  },
  {
    "State": "IN",
    "County": "Owen",
    "NumberofStores": 31
  },
  {
    "State": "IN",
    "County": "Parke",
    "NumberofStores": 27
  },
  {
    "State": "IN",
    "County": "Perry",
    "NumberofStores": 53
  },
  {
    "State": "IN",
    "County": "Pike",
    "NumberofStores": 47
  },
  {
    "State": "IN",
    "County": "Porter",
    "NumberofStores": 317
  },
  {
    "State": "IN",
    "County": "Posey",
    "NumberofStores": 37
  },
  {
    "State": "IN",
    "County": "Pulaski",
    "NumberofStores": 29
  },
  {
    "State": "IN",
    "County": "Putnam",
    "NumberofStores": 57
  },
  {
    "State": "IN",
    "County": "Randolph",
    "NumberofStores": 97
  },
  {
    "State": "IN",
    "County": "Ripley",
    "NumberofStores": 117
  },
  {
    "State": "IN",
    "County": "Rush",
    "NumberofStores": 89
  },
  {
    "State": "IN",
    "County": "Scott",
    "NumberofStores": 23
  },
  {
    "State": "IN",
    "County": "Shelby",
    "NumberofStores": 83
  },
  {
    "State": "IN",
    "County": "Spencer",
    "NumberofStores": 41
  },
  {
    "State": "IN",
    "County": "St. Joseph",
    "NumberofStores": 347
  },
  {
    "State": "IN",
    "County": "Starke",
    "NumberofStores": 29
  },
  {
    "State": "IN",
    "County": "Steuben County",
    "NumberofStores": 73
  },
  {
    "State": "IN",
    "County": "Sullivan",
    "NumberofStores": 137
  },
  {
    "State": "IN",
    "County": "Switzerland",
    "NumberofStores": 17
  },
  {
    "State": "IN",
    "County": "Tippecanoe",
    "NumberofStores": 487
  },
  {
    "State": "IN",
    "County": "Tipton",
    "NumberofStores": 43
  },
  {
    "State": "IN",
    "County": "Union",
    "NumberofStores": 11
  },
  {
    "State": "IN",
    "County": "Vanderburgh",
    "NumberofStores": 397
  },
  {
    "State": "IN",
    "County": "Vermillion",
    "NumberofStores": 33
  },
  {
    "State": "IN",
    "County": "Vigo",
    "NumberofStores": 317
  },
  {
    "State": "IN",
    "County": "Wabash County",
    "NumberofStores": 57
  },
  {
    "State": "IN",
    "County": "Warren",
    "NumberofStores": 19
  },
  {
    "State": "IN",
    "County": "Warrick",
    "NumberofStores": 263
  },
  {
    "State": "IN",
    "County": "Washington",
    "NumberofStores": 97
  },
  {
    "State": "IN",
    "County": "Wayne",
    "NumberofStores": 173
  },
  {
    "State": "IN",
    "County": "Wells County",
    "NumberofStores": 61
  },
  {
    "State": "IN",
    "County": "White",
    "NumberofStores": 247
  },
  {
    "State": "IN",
    "County": "Whitley County",
    "NumberofStores": 53
  },
  {
    "State": "KS",
    "County": "Allen",
    "NumberofStores": 127
  },
  {
    "State": "KS",
    "County": "Anderson",
    "NumberofStores": 137
  },
  {
    "State": "KS",
    "County": "Atchison",
    "NumberofStores": 61
  },
  {
    "State": "KS",
    "County": "Barber",
    "NumberofStores": 19
  },
  {
    "State": "KS",
    "County": "Barton",
    "NumberofStores": 83
  },
  {
    "State": "KS",
    "County": "Bourbon",
    "NumberofStores": 57
  },
  {
    "State": "KS",
    "County": "Brown",
    "NumberofStores": 63
  },
  {
    "State": "KS",
    "County": "Butler",
    "NumberofStores": 197
  },
  {
    "State": "KS",
    "County": "Chase",
    "NumberofStores": 23
  },
  {
    "State": "KS",
    "County": "Chautauqua",
    "NumberofStores": 29
  },
  {
    "State": "KS",
    "County": "Cherokee",
    "NumberofStores": 73
  },
  {
    "State": "KS",
    "County": "Cheyenne",
    "NumberofStores": 21
  },
  {
    "State": "KS",
    "County": "Clark",
    "NumberofStores": 17
  },
  {
    "State": "KS",
    "County": "Clay",
    "NumberofStores": 53
  },
  {
    "State": "KS",
    "County": "Cloud",
    "NumberofStores": 41
  },
  {
    "State": "KS",
    "County": "Coffey",
    "NumberofStores": 47
  },
  {
    "State": "KS",
    "County": "Comanche",
    "NumberofStores": 11
  },
  {
    "State": "KS",
    "County": "Cowley",
    "NumberofStores": 143
  },
  {
    "State": "KS",
    "County": "Crawford",
    "NumberofStores": 127
  },
  {
    "State": "KS",
    "County": "Decatur",
    "NumberofStores": 29
  },
  {
    "State": "KS",
    "County": "Dickinson",
    "NumberofStores": 67
  },
  {
    "State": "KS",
    "County": "Doniphan",
    "NumberofStores": 49
  },
  {
    "State": "KS",
    "County": "Douglas",
    "NumberofStores": 173
  },
  {
    "State": "KS",
    "County": "Edwards",
    "NumberofStores": 13
  },
  {
    "State": "KS",
    "County": "Elk",
    "NumberofStores": 19
  },
  {
    "State": "KS",
    "County": "Ellis",
    "NumberofStores": 89
  },
  {
    "State": "KS",
    "County": "Ellsworth",
    "NumberofStores": 31
  },
  {
    "State": "KS",
    "County": "Finney",
    "NumberofStores": 213
  },
  {
    "State": "KS",
    "County": "Ford",
    "NumberofStores": 193
  },
  {
    "State": "KS",
    "County": "Franklin",
    "NumberofStores": 97
  },
  {
    "State": "KS",
    "County": "Geary",
    "NumberofStores": 83
  },
  {
    "State": "KS",
    "County": "Gove",
    "NumberofStores": 11
  },
  {
    "State": "KS",
    "County": "Graham",
    "NumberofStores": 17
  },
  {
    "State": "KS",
    "County": "Grant",
    "NumberofStores": 19
  },
  {
    "State": "KS",
    "County": "Gray",
    "NumberofStores": 41
  },
  {
    "State": "KS",
    "County": "Greeley",
    "NumberofStores": 7
  },
  {
    "State": "KS",
    "County": "Greenwood",
    "NumberofStores": 37
  },
  {
    "State": "KS",
    "County": "Hamilton",
    "NumberofStores": 9
  },
  {
    "State": "KS",
    "County": "Harper",
    "NumberofStores": 29
  },
  {
    "State": "KS",
    "County": "Harvey",
    "NumberofStores": 167
  },
  {
    "State": "KS",
    "County": "Haskell",
    "NumberofStores": 23
  },
  {
    "State": "KS",
    "County": "Hodgeman",
    "NumberofStores": 11
  },
  {
    "State": "KS",
    "County": "Jackson",
    "NumberofStores": 71
  },
  {
    "State": "KS",
    "County": "Jefferson",
    "NumberofStores": 73
  },
  {
    "State": "KS",
    "County": "Jewell",
    "NumberofStores": 27
  },
  {
    "State": "KS",
    "County": "Johnson",
    "NumberofStores": 913
  },
  {
    "State": "KS",
    "County": "Kearny",
    "NumberofStores": 19
  },
  {
    "State": "KS",
    "County": "Kingman",
    "NumberofStores": 53
  },
  {
    "State": "KS",
    "County": "Kiowa",
    "NumberofStores": 17
  },
  {
    "State": "KS",
    "County": "Labette",
    "NumberofStores": 83
  },
  {
    "State": "KS",
    "County": "Lane",
    "NumberofStores": 9
  },
  {
    "State": "KS",
    "County": "Leavenworth",
    "NumberofStores": 137
  },
  {
    "State": "KS",
    "County": "Lincoln",
    "NumberofStores": 29
  },
  {
    "State": "KS",
    "County": "Linn",
    "NumberofStores": 47
  },
  {
    "State": "KS",
    "County": "Logan",
    "NumberofStores": 13
  },
  {
    "State": "KS",
    "County": "Lyon",
    "NumberofStores": 183
  },
  {
    "State": "KS",
    "County": "Marion",
    "NumberofStores": 61
  },
  {
    "State": "KS",
    "County": "Marshall",
    "NumberofStores": 73
  },
  {
    "State": "KS",
    "County": "McPherson",
    "NumberofStores": 157
  },
  {
    "State": "KS",
    "County": "Meade",
    "NumberofStores": 21
  },
  {
    "State": "KS",
    "County": "Miami",
    "NumberofStores": 117
  },
  {
    "State": "KS",
    "County": "Mitchell",
    "NumberofStores": 41
  },
  {
    "State": "KS",
    "County": "Montgomery",
    "NumberofStores": 127
  },
  {
    "State": "KS",
    "County": "Morris",
    "NumberofStores": 53
  },
  {
    "State": "KS",
    "County": "Morton",
    "NumberofStores": 13
  },
  {
    "State": "KS",
    "County": "Nemaha",
    "NumberofStores": 49
  },
  {
    "State": "KS",
    "County": "Neosho",
    "NumberofStores": 73
  },
  {
    "State": "KS",
    "County": "Ness",
    "NumberofStores": 17
  },
  {
    "State": "KS",
    "County": "Norton",
    "NumberofStores": 29
  },
  {
    "State": "KS",
    "County": "Osage",
    "NumberofStores": 63
  },
  {
    "State": "KS",
    "County": "Osborne",
    "NumberofStores": 23
  },
  {
    "State": "KS",
    "County": "Ottawa",
    "NumberofStores": 37
  },
  {
    "State": "KS",
    "County": "Pawnee",
    "NumberofStores": 41
  },
  {
    "State": "KS",
    "County": "Phillips",
    "NumberofStores": 29
  },
  {
    "State": "KS",
    "County": "Pottawatomie",
    "NumberofStores": 31
  },
  {
    "State": "KS",
    "County": "Pratt",
    "NumberofStores": 83
  },
  {
    "State": "KS",
    "County": "Rawlins",
    "NumberofStores": 43
  },
  {
    "State": "KS",
    "County": "Reno",
    "NumberofStores": 21
  },
  {
    "State": "KS",
    "County": "Republic",
    "NumberofStores": 197
  },
  {
    "State": "KS",
    "County": "Rice",
    "NumberofStores": 39
  },
  {
    "State": "KS",
    "County": "Riley",
    "NumberofStores": 53
  },
  {
    "State": "KS",
    "County": "Rooks",
    "NumberofStores": 97
  },
  {
    "State": "KS",
    "County": "Rush",
    "NumberofStores": 27
  },
  {
    "State": "KS",
    "County": "Russell",
    "NumberofStores": 19
  },
  {
    "State": "KS",
    "County": "Saline",
    "NumberofStores": 41
  },
  {
    "State": "KS",
    "County": "Scott",
    "NumberofStores": 173
  },
  {
    "State": "KS",
    "County": "Sedgwick",
    "NumberofStores": 23
  },
  {
    "State": "KS",
    "County": "Seward",
    "NumberofStores": 847
  },
  {
    "State": "KS",
    "County": "Shawnee",
    "NumberofStores": 127
  },
  {
    "State": "KS",
    "County": "Sheridan",
    "NumberofStores": 397
  },
  {
    "State": "KS",
    "County": "Sherman",
    "NumberofStores": 17
  },
  {
    "State": "KS",
    "County": "Smith",
    "NumberofStores": 21
  },
  {
    "State": "KS",
    "County": "Stafford",
    "NumberofStores": 27
  },
  {
    "State": "KS",
    "County": "Stanton",
    "NumberofStores": 33
  },
  {
    "State": "KS",
    "County": "Stevens",
    "NumberofStores": 11
  },
  {
    "State": "KS",
    "County": "Sumner",
    "NumberofStores": 19
  },
  {
    "State": "KS",
    "County": "Thomas",
    "NumberofStores": 213
  },
  {
    "State": "KS",
    "County": "Trego",
    "NumberofStores": 29
  },
  {
    "State": "KS",
    "County": "Wabaunsee",
    "NumberofStores": 17
  },
  {
    "State": "KS",
    "County": "Wallace",
    "NumberofStores": 47
  },
  {
    "State": "KS",
    "County": "Washington",
    "NumberofStores": 9
  },
  {
    "State": "KS",
    "County": "Wichita",
    "NumberofStores": 53
  },
  {
    "State": "KS",
    "County": "Wilson",
    "NumberofStores": 7
  },
  {
    "State": "KS",
    "County": "Woodson",
    "NumberofStores": 83
  },
  {
    "State": "KS",
    "County": "Wyandotte",
    "NumberofStores": 29
  },
  {
    "State": "KY",
    "County": "Adair",
    "NumberofStores": 317
  },
  {
    "State": "KY",
    "County": "Allen",
    "NumberofStores": 73
  },
  {
    "State": "KY",
    "County": "Anderson",
    "NumberofStores": 67
  },
  {
    "State": "KY",
    "County": "Ballard",
    "NumberofStores": 21
  },
  {
    "State": "KY",
    "County": "Barren",
    "NumberofStores": 143
  },
  {
    "State": "KY",
    "County": "Bath",
    "NumberofStores": 29
  },
  {
    "State": "KY",
    "County": "Bell",
    "NumberofStores": 83
  },
  {
    "State": "KY",
    "County": "Boone",
    "NumberofStores": 317
  },
  {
    "State": "KY",
    "County": "Bourbon",
    "NumberofStores": 53
  },
  {
    "State": "KY",
    "County": "Boyd",
    "NumberofStores": 167
  },
  {
    "State": "KY",
    "County": "Boyle",
    "NumberofStores": 79
  },
  {
    "State": "KY",
    "County": "Bracken",
    "NumberofStores": 27
  },
  {
    "State": "KY",
    "County": "Breathitt",
    "NumberofStores": 41
  },
  {
    "State": "KY",
    "County": "Breckinridge",
    "NumberofStores": 97
  },
  {
    "State": "KY",
    "County": "Bullitt",
    "NumberofStores": 263
  },
  {
    "State": "KY",
    "County": "Butler",
    "NumberofStores": 63
  },
  {
    "State": "KY",
    "County": "Caldwell",
    "NumberofStores": 57
  },
  {
    "State": "KY",
    "County": "Calloway",
    "NumberofStores": 127
  },
  {
    "State": "KY",
    "County": "Campbell",
    "NumberofStores": 213
  },
  {
    "State": "KY",
    "County": "Carlisle",
    "NumberofStores": 19
  },
  {
    "State": "KY",
    "County": "Carroll",
    "NumberofStores": 47
  },
  {
    "State": "KY",
    "County": "Carter",
    "NumberofStores": 117
  },
  {
    "State": "KY",
    "County": "Casey",
    "NumberofStores": 61
  },
  {
    "State": "KY",
    "County": "Christian",
    "NumberofStores": 197
  },
  {
    "State": "KY",
    "County": "Clark",
    "NumberofStores": 89
  },
  {
    "State": "KY",
    "County": "Clay",
    "NumberofStores": 73
  },
  {
    "State": "KY",
    "County": "Clinton",
    "NumberofStores": 31
  },
  {
    "State": "KY",
    "County": "Crittenden",
    "NumberofStores": 43
  },
  {
    "State": "KY",
    "County": "Cumberland",
    "NumberofStores": 23
  },
  {
    "State": "KY",
    "County": "Daviess",
    "NumberofStores": 213
  },
  {
    "State": "KY",
    "County": "Edmonson",
    "NumberofStores": 37
  },
  {
    "State": "KY",
    "County": "Elliott",
    "NumberofStores": 19
  },
  {
    "State": "KY",
    "County": "Estill",
    "NumberofStores": 41
  },
  {
    "State": "KY",
    "County": "Fayette",
    "NumberofStores": 487
  },
  {
    "State": "KY",
    "County": "Fleming",
    "NumberofStores": 71
  },
  {
    "State": "KY",
    "County": "Floyd",
    "NumberofStores": 173
  },
  {
    "State": "KY",
    "County": "Franklin",
    "NumberofStores": 113
  },
  {
    "State": "KY",
    "County": "Fulton",
    "NumberofStores": 29
  },
  {
    "State": "KY",
    "County": "Gallatin",
    "NumberofStores": 33
  },
  {
    "State": "KY",
    "County": "Garrard",
    "NumberofStores": 61
  },
  {
    "State": "KY",
    "County": "Grant",
    "NumberofStores": 73
  },
  {
    "State": "KY",
    "County": "Graves",
    "NumberofStores": 183
  },
  {
    "State": "KY",
    "County": "Grayson",
    "NumberofStores": 137
  },
  {
    "State": "KY",
    "County": "Green",
    "NumberofStores": 53
  },
  {
    "State": "KY",
    "County": "Greenup",
    "NumberofStores": 117
  },
  {
    "State": "KY",
    "County": "Hancock",
    "NumberofStores": 41
  },
  {
    "State": "KY",
    "County": "Hardin",
    "NumberofStores": 327
  },
  {
    "State": "KY",
    "County": "Harlan",
    "NumberofStores": 83
  },
  {
    "State": "KY",
    "County": "Harrison",
    "NumberofStores": 97
  },
  {
    "State": "KY",
    "County": "Hart",
    "NumberofStores": 67
  },
  {
    "State": "KY",
    "County": "Henderson",
    "NumberofStores": 173
  },
  {
    "State": "KY",
    "County": "Henry",
    "NumberofStores": 63
  },
  {
    "State": "KY",
    "County": "Hickman",
    "NumberofStores": 27
  },
  {
    "State": "KY",
    "County": "Hopkins",
    "NumberofStores": 167
  },
  {
    "State": "KY",
    "County": "Jackson",
    "NumberofStores": 57
  },
  {
    "State": "KY",
    "County": "Jefferson",
    "NumberofStores": 913
  },
  {
    "State": "KY",
    "County": "Jessamine",
    "NumberofStores": 193
  },
  {
    "State": "KY",
    "County": "Johnson",
    "NumberofStores": 137
  },
  {
    "State": "KY",
    "County": "Kenton",
    "NumberofStores": 317
  },
  {
    "State": "KY",
    "County": "Knott",
    "NumberofStores": 29
  },
  {
    "State": "KY",
    "County": "Knox",
    "NumberofStores": 83
  },
  {
    "State": "KY",
    "County": "Larue",
    "NumberofStores": 49
  },
  {
    "State": "KY",
    "County": "Laurel",
    "NumberofStores": 143
  },
  {
    "State": "KY",
    "County": "Lawrence",
    "NumberofStores": 97
  },
  {
    "State": "KY",
    "County": "Lee",
    "NumberofStores": 23
  },
  {
    "State": "KY",
    "County": "Leslie",
    "NumberofStores": 31
  },
  {
    "State": "KY",
    "County": "Letcher",
    "NumberofStores": 29
  },
  {
    "State": "KY",
    "County": "Lewis",
    "NumberofStores": 37
  },
  {
    "State": "KY",
    "County": "Lincoln",
    "NumberofStores": 61
  },
  {
    "State": "KY",
    "County": "Livingston",
    "NumberofStores": 29
  },
  {
    "State": "KY",
    "County": "Logan",
    "NumberofStores": 127
  },
  {
    "State": "KY",
    "County": "Lyon",
    "NumberofStores": 19
  },
  {
    "State": "KY",
    "County": "Madison",
    "NumberofStores": 173
  },
  {
    "State": "KY",
    "County": "Magoffin",
    "NumberofStores": 41
  },
  {
    "State": "KY",
    "County": "Marion",
    "NumberofStores": 89
  },
  {
    "State": "KY",
    "County": "Marshall",
    "NumberofStores": 117
  },
  {
    "State": "KY",
    "County": "Martin",
    "NumberofStores": 23
  },
  {
    "State": "KY",
    "County": "Mason",
    "NumberofStores": 47
  },
  {
    "State": "KY",
    "County": "McCracken",
    "NumberofStores": 287
  },
  {
    "State": "KY",
    "County": "McCreary",
    "NumberofStores": 21
  },
  {
    "State": "KY",
    "County": "McLean",
    "NumberofStores": 53
  },
  {
    "State": "KY",
    "County": "Meade",
    "NumberofStores": 137
  },
  {
    "State": "KY",
    "County": "Menifee",
    "NumberofStores": 17
  },
  {
    "State": "KY",
    "County": "Mercer",
    "NumberofStores": 67
  },
  {
    "State": "KY",
    "County": "Metcalfe",
    "NumberofStores": 49
  },
  {
    "State": "KY",
    "County": "Monroe",
    "NumberofStores": 27
  },
  {
    "State": "KY",
    "County": "Montgomery",
    "NumberofStores": 97
  },
  {
    "State": "KY",
    "County": "Morgan",
    "NumberofStores": 53
  },
  {
    "State": "KY",
    "County": "Muhlenberg",
    "NumberofStores": 197
  },
  {
    "State": "KY",
    "County": "Nelson",
    "NumberofStores": 163
  },
  {
    "State": "KY",
    "County": "Nicholas",
    "NumberofStores": 41
  },
  {
    "State": "KY",
    "County": "Ohio",
    "NumberofStores": 113
  },
  {
    "State": "KY",
    "County": "Oldham",
    "NumberofStores": 233
  },
  {
    "State": "KY",
    "County": "Owen",
    "NumberofStores": 37
  },
  {
    "State": "KY",
    "County": "Owsley",
    "NumberofStores": 19
  },
  {
    "State": "KY",
    "County": "Pendleton",
    "NumberofStores": 71
  },
  {
    "State": "KY",
    "County": "Perry",
    "NumberofStores": 83
  },
  {
    "State": "KY",
    "County": "Pike",
    "NumberofStores": 347
  },
  {
    "State": "KY",
    "County": "Powell",
    "NumberofStores": 61
  },
  {
    "State": "KY",
    "County": "Pulaski",
    "NumberofStores": 197
  },
  {
    "State": "KY",
    "County": "Robertson",
    "NumberofStores": 11
  },
  {
    "State": "KY",
    "County": "Rockcastle",
    "NumberofStores": 97
  },
  {
    "State": "KY",
    "County": "Rowan",
    "NumberofStores": 137
  },
  {
    "State": "KY",
    "County": "Russell",
    "NumberofStores": 113
  },
  {
    "State": "KY",
    "County": "Scott",
    "NumberofStores": 173
  },
  {
    "State": "KY",
    "County": "Shelby",
    "NumberofStores": 247
  },
  {
    "State": "KY",
    "County": "Simpson",
    "NumberofStores": 143
  },
  {
    "State": "KY",
    "County": "Spencer",
    "NumberofStores": 83
  },
  {
    "State": "KY",
    "County": "Taylor",
    "NumberofStores": 67
  },
  {
    "State": "KY",
    "County": "Todd",
    "NumberofStores": 97
  },
  {
    "State": "KY",
    "County": "Trigg",
    "NumberofStores": 57
  },
  {
    "State": "KY",
    "County": "Trimble",
    "NumberofStores": 73
  },
  {
    "State": "KY",
    "County": "Union",
    "NumberofStores": 53
  },
  {
    "State": "KY",
    "County": "Warren",
    "NumberofStores": 39
  },
  {
    "State": "KY",
    "County": "Washington",
    "NumberofStores": 63
  },
  {
    "State": "KY",
    "County": "Wayne",
    "NumberofStores": 213
  },
  {
    "State": "KY",
    "County": "Webster",
    "NumberofStores": 67
  },
  {
    "State": "KY",
    "County": "Whitley",
    "NumberofStores": 89
  },
  {
    "State": "KY",
    "County": "Wolfe",
    "NumberofStores": 83
  },
  {
    "State": "KY",
    "County": "Woodford",
    "NumberofStores": 117
  },
  {
    "State": "LA",
    "County": "Allen Parish",
    "NumberofStores": 31
  },
  {
    "State": "LA",
    "County": "Avoyelles Parish",
    "NumberofStores": 83
  },
  {
    "State": "LA",
    "County": "Beauregard Parish",
    "NumberofStores": 97
  },
  {
    "State": "LA",
    "County": "Bienville Parish",
    "NumberofStores": 29
  },
  {
    "State": "LA",
    "County": "Bossier Parish",
    "NumberofStores": 213
  },
  {
    "State": "LA",
    "County": "Caddo Parish",
    "NumberofStores": 347
  },
  {
    "State": "LA",
    "County": "Calcasieu Parish",
    "NumberofStores": 287
  },
  {
    "State": "LA",
    "County": "Caldwell Parish",
    "NumberofStores": 21
  },
  {
    "State": "LA",
    "County": "Cameron Parish",
    "NumberofStores": 11
  },
  {
    "State": "LA",
    "County": "Catahoula Parish",
    "NumberofStores": 19
  },
  {
    "State": "LA",
    "County": "Claiborne Parish",
    "NumberofStores": 41
  },
  {
    "State": "LA",
    "County": "Concordia Parish",
    "NumberofStores": 53
  },
  {
    "State": "LA",
    "County": "De Soto Parish",
    "NumberofStores": 67
  },
  {
    "State": "LA",
    "County": "East Carroll Parish",
    "NumberofStores": 17
  },
  {
    "State": "LA",
    "County": "Franklin Parish",
    "NumberofStores": 47
  },
  {
    "State": "LA",
    "County": "Grant Parish",
    "NumberofStores": 61
  },
  {
    "State": "LA",
    "County": "Jackson Parish",
    "NumberofStores": 43
  },
  {
    "State": "LA",
    "County": "Jefferson Davis Parish",
    "NumberofStores": 73
  },
  {
    "State": "LA",
    "County": "La Salle Parish",
    "NumberofStores": 23
  },
  {
    "State": "LA",
    "County": "Lincoln Parish",
    "NumberofStores": 117
  },
  {
    "State": "LA",
    "County": "Madison Parish",
    "NumberofStores": 19
  },
  {
    "State": "LA",
    "County": "Morehouse Parish",
    "NumberofStores": 79
  },
  {
    "State": "LA",
    "County": "Natchitoches Parish",
    "NumberofStores": 83
  },
  {
    "State": "LA",
    "County": "Ouachita Parish",
    "NumberofStores": 197
  },
  {
    "State": "LA",
    "County": "Rapides Parish",
    "NumberofStores": 263
  },
  {
    "State": "LA",
    "County": "Red River Parish",
    "NumberofStores": 13
  },
  {
    "State": "LA",
    "County": "Richland Parish",
    "NumberofStores": 57
  },
  {
    "State": "LA",
    "County": "Sabine Parish",
    "NumberofStores": 71
  },
  {
    "State": "LA",
    "County": "Tensas Parish",
    "NumberofStores": 11
  },
  {
    "State": "LA",
    "County": "Union Parish",
    "NumberofStores": 73
  },
  {
    "State": "LA",
    "County": "Vernon Parish",
    "NumberofStores": 97
  },
  {
    "State": "LA",
    "County": "Webster Parish",
    "NumberofStores": 89
  },
  {
    "State": "LA",
    "County": "West Carroll Parish",
    "NumberofStores": 17
  },
  {
    "State": "LA",
    "County": "Winn Parish",
    "NumberofStores": 41
  },
  {
    "State": "MI",
    "County": "Alcona",
    "NumberofStores": 19
  },
  {
    "State": "MI",
    "County": "Allegan",
    "NumberofStores": 173
  },
  {
    "State": "MI",
    "County": "Alpena",
    "NumberofStores": 61
  },
  {
    "State": "MI",
    "County": "Antrim",
    "NumberofStores": 41
  },
  {
    "State": "MI",
    "County": "Arenac",
    "NumberofStores": 29
  },
  {
    "State": "MI",
    "County": "Barry",
    "NumberofStores": 113
  },
  {
    "State": "MI",
    "County": "Bay",
    "NumberofStores": 197
  },
  {
    "State": "MI",
    "County": "Benzie",
    "NumberofStores": 47
  },
  {
    "State": "MI",
    "County": "Berrien",
    "NumberofStores": 317
  },
  {
    "State": "MI",
    "County": "Branch",
    "NumberofStores": 83
  },
  {
    "State": "MI",
    "County": "Calhoun",
    "NumberofStores": 263
  },
  {
    "State": "MI",
    "County": "Cass",
    "NumberofStores": 97
  },
  {
    "State": "MI",
    "County": "Charlevoix",
    "NumberofStores": 53
  },
  {
    "State": "MI",
    "County": "Cheboygan",
    "NumberofStores": 57
  },
  {
    "State": "MI",
    "County": "Clare",
    "NumberofStores": 41
  },
  {
    "State": "MI",
    "County": "Clinton",
    "NumberofStores": 127
  },
  {
    "State": "MI",
    "County": "Crawford",
    "NumberofStores": 23
  },
  {
    "State": "MI",
    "County": "Eaton",
    "NumberofStores": 183
  },
  {
    "State": "MI",
    "County": "Emmet",
    "NumberofStores": 79
  },
  {
    "State": "MI",
    "County": "Genesee",
    "NumberofStores": 547
  },
  {
    "State": "MI",
    "County": "Gladwin",
    "NumberofStores": 37
  },
  {
    "State": "MI",
    "County": "Grand Traverse",
    "NumberofStores": 167
  },
  {
    "State": "MI",
    "County": "Gratiot",
    "NumberofStores": 73
  },
  {
    "State": "MI",
    "County": "Hillsdale",
    "NumberofStores": 97
  },
  {
    "State": "MI",
    "County": "Huron",
    "NumberofStores": 63
  },
  {
    "State": "MI",
    "County": "Ingham",
    "NumberofStores": 287
  },
  {
    "State": "MI",
    "County": "Ionia",
    "NumberofStores": 117
  },
  {
    "State": "MI",
    "County": "Iosco",
    "NumberofStores": 43
  },
  {
    "State": "MI",
    "County": "Iron",
    "NumberofStores": 27
  },
  {
    "State": "MI",
    "County": "Isabella",
    "NumberofStores": 143
  },
  {
    "State": "MI",
    "County": "Jackson",
    "NumberofStores": 213
  },
  {
    "State": "MI",
    "County": "Kalamazoo",
    "NumberofStores": 347
  },
  {
    "State": "MI",
    "County": "Kalkaska",
    "NumberofStores": 31
  },
  {
    "State": "MI",
    "County": "Kent",
    "NumberofStores": 693
  },
  {
    "State": "MI",
    "County": "Lake",
    "NumberofStores": 29
  },
  {
    "State": "MI",
    "County": "Lapeer",
    "NumberofStores": 97
  },
  {
    "State": "MI",
    "County": "Leelanau",
    "NumberofStores": 49
  },
  {
    "State": "MI",
    "County": "Lenawee",
    "NumberofStores": 137
  },
  {
    "State": "MI",
    "County": "Livingston",
    "NumberofStores": 263
  },
  {
    "State": "MI",
    "County": "Macomb",
    "NumberofStores": 787
  },
  {
    "State": "MI",
    "County": "Manistee",
    "NumberofStores": 71
  },
  {
    "State": "MI",
    "County": "Mason",
    "NumberofStores": 83
  },
  {
    "State": "MI",
    "County": "Mecosta",
    "NumberofStores": 117
  },
  {
    "State": "MI",
    "County": "Midland",
    "NumberofStores": 163
  },
  {
    "State": "MI",
    "County": "Missaukee",
    "NumberofStores": 33
  },
  {
    "State": "MI",
    "County": "Monroe",
    "NumberofStores": 197
  },
  {
    "State": "MI",
    "County": "Montcalm",
    "NumberofStores": 143
  },
  {
    "State": "MI",
    "County": "Montmorency",
    "NumberofStores": 21
  },
  {
    "State": "MI",
    "County": "Muskegon",
    "NumberofStores": 247
  },
  {
    "State": "MI",
    "County": "Newaygo",
    "NumberofStores": 127
  },
  {
    "State": "MI",
    "County": "Oakland",
    "NumberofStores": 913
  },
  {
    "State": "MI",
    "County": "Oceana",
    "NumberofStores": 89
  },
  {
    "State": "MI",
    "County": "Ogemaw",
    "NumberofStores": 37
  },
  {
    "State": "MI",
    "County": "Osceola",
    "NumberofStores": 61
  },
  {
    "State": "MI",
    "County": "Oscoda",
    "NumberofStores": 29
  },
  {
    "State": "MI",
    "County": "Otsego",
    "NumberofStores": 41
  },
  {
    "State": "MI",
    "County": "Ottawa",
    "NumberofStores": 397
  },
  {
    "State": "MI",
    "County": "Presque Isle",
    "NumberofStores": 23
  },
  {
    "State": "MI",
    "County": "Roscommon",
    "NumberofStores": 47
  },
  {
    "State": "MI",
    "County": "Saginaw",
    "NumberofStores": 317
  },
  {
    "State": "MI",
    "County": "Sanilac",
    "NumberofStores": 73
  },
  {
    "State": "MI",
    "County": "Shiawassee",
    "NumberofStores": 137
  },
  {
    "State": "MI",
    "County": "St. Clair",
    "NumberofStores": 247
  },
  {
    "State": "MI",
    "County": "St. Joseph",
    "NumberofStores": 193
  },
  {
    "State": "MI",
    "County": "Tuscola",
    "NumberofStores": 83
  },
  {
    "State": "MI",
    "County": "Van Buren",
    "NumberofStores": 167
  },
  {
    "State": "MI",
    "County": "Washtenaw",
    "NumberofStores": 213
  },
  {
    "State": "MI",
    "County": "Wayne",
    "NumberofStores": 389
  },
  {
    "State": "MI",
    "County": "Wexford",
    "NumberofStores": 1127
  },
  {
    "State": "MN",
    "County": "Anoka",
    "NumberofStores": 173
  },
  {
    "State": "MN",
    "County": "Becker",
    "NumberofStores": 73
  },
  {
    "State": "MN",
    "County": "Benton County",
    "NumberofStores": 83
  },
  {
    "State": "MN",
    "County": "Blue Earth",
    "NumberofStores": 127
  },
  {
    "State": "MN",
    "County": "Brown",
    "NumberofStores": 61
  },
  {
    "State": "MN",
    "County": "Carlton",
    "NumberofStores": 89
  },
  {
    "State": "MN",
    "County": "Carver",
    "NumberofStores": 173
  },
  {
    "State": "MN",
    "County": "Chisago",
    "NumberofStores": 147
  },
  {
    "State": "MN",
    "County": "Clay",
    "NumberofStores": 113
  },
  {
    "State": "MN",
    "County": "Cook",
    "NumberofStores": 21
  },
  {
    "State": "MN",
    "County": "Cottonwood",
    "NumberofStores": 57
  },
  {
    "State": "MN",
    "County": "Dakota",
    "NumberofStores": 397
  },
  {
    "State": "MN",
    "County": "Dodge",
    "NumberofStores": 47
  },
  {
    "State": "MN",
    "County": "Douglas County",
    "NumberofStores": 97
  },
  {
    "State": "MN",
    "County": "Faribault",
    "NumberofStores": 83
  },
  {
    "State": "MN",
    "County": "Fillmore",
    "NumberofStores": 71
  },
  {
    "State": "MN",
    "County": "Freeborn",
    "NumberofStores": 117
  },
  {
    "State": "MN",
    "County": "Goodhue",
    "NumberofStores": 137
  },
  {
    "State": "MN",
    "County": "Grant",
    "NumberofStores": 29
  },
  {
    "State": "MN",
    "County": "Hennepin",
    "NumberofStores": 937
  },
  {
    "State": "MN",
    "County": "Houston",
    "NumberofStores": 39
  },
  {
    "State": "MN",
    "County": "Isanti",
    "NumberofStores": 97
  },
  {
    "State": "MN",
    "County": "Jackson",
    "NumberofStores": 53
  },
  {
    "State": "MN",
    "County": "Kanabec",
    "NumberofStores": 41
  },
  {
    "State": "MN",
    "County": "Kandiyohi",
    "NumberofStores": 123
  },
  {
    "State": "MN",
    "County": "Lake",
    "NumberofStores": 27
  },
  {
    "State": "MN",
    "County": "Le Sueur",
    "NumberofStores": 79
  },
  {
    "State": "MN",
    "County": "Lincoln",
    "NumberofStores": 31
  },
  {
    "State": "MN",
    "County": "Lyon",
    "NumberofStores": 113
  },
  {
    "State": "MN",
    "County": "Mahnomen",
    "NumberofStores": 19
  },
  {
    "State": "MN",
    "County": "Martin",
    "NumberofStores": 83
  },
  {
    "State": "MN",
    "County": "McLeod",
    "NumberofStores": 117
  },
  {
    "State": "MN",
    "County": "Meeker County",
    "NumberofStores": 73
  },
  {
    "State": "MN",
    "County": "Morrison County",
    "NumberofStores": 97
  },
  {
    "State": "MN",
    "County": "Mower",
    "NumberofStores": 143
  },
  {
    "State": "MN",
    "County": "Murray",
    "NumberofStores": 41
  },
  {
    "State": "MN",
    "County": "Nicollet",
    "NumberofStores": 89
  },
  {
    "State": "MN",
    "County": "Nobles",
    "NumberofStores": 97
  },
  {
    "State": "MN",
    "County": "Norman",
    "NumberofStores": 43
  },
  {
    "State": "MN",
    "County": "Olmsted",
    "NumberofStores": 287
  },
  {
    "State": "MN",
    "County": "Otter Tail",
    "NumberofStores": 173
  },
  {
    "State": "MN",
    "County": "Pine",
    "NumberofStores": 83
  },
  {
    "State": "MN",
    "County": "Pipestone",
    "NumberofStores": 37
  },
  {
    "State": "MN",
    "County": "Pope County",
    "NumberofStores": 61
  },
  {
    "State": "MN",
    "County": "Ramsey",
    "NumberofStores": 913
  },
  {
    "State": "MN",
    "County": "Redwood",
    "NumberofStores": 73
  },
  {
    "State": "MN",
    "County": "Renville",
    "NumberofStores": 83
  },
  {
    "State": "MN",
    "County": "Rice",
    "NumberofStores": 137
  },
  {
    "State": "MN",
    "County": "Rock",
    "NumberofStores": 29
  },
  {
    "State": "MN",
    "County": "Scott",
    "NumberofStores": 213
  },
  {
    "State": "MN",
    "County": "Sherburne",
    "NumberofStores": 197
  },
  {
    "State": "MN",
    "County": "Sibley County",
    "NumberofStores": 67
  },
  {
    "State": "MN",
    "County": "Stearns County",
    "NumberofStores": 247
  },
  {
    "State": "MN",
    "County": "Steele",
    "NumberofStores": 127
  },
  {
    "State": "MN",
    "County": "Stevens County",
    "NumberofStores": 43
  },
  {
    "State": "MN",
    "County": "Swift County",
    "NumberofStores": 31
  },
  {
    "State": "MN",
    "County": "Todd County",
    "NumberofStores": 41
  },
  {
    "State": "MN",
    "County": "Traverse",
    "NumberofStores": 73
  },
  {
    "State": "MN",
    "County": "Wabasha",
    "NumberofStores": 17
  },
  {
    "State": "MN",
    "County": "Waseca",
    "NumberofStores": 63
  },
  {
    "State": "MN",
    "County": "Washington",
    "NumberofStores": 97
  },
  {
    "State": "MN",
    "County": "Watonwan",
    "NumberofStores": 397
  },
  {
    "State": "MN",
    "County": "Wilkin",
    "NumberofStores": 29
  },
  {
    "State": "MN",
    "County": "Winona",
    "NumberofStores": 41
  },
  {
    "State": "MN",
    "County": "Wright",
    "NumberofStores": 173
  },
  {
    "State": "MO",
    "County": "Andrew",
    "NumberofStores": 263
  },
  {
    "State": "MO",
    "County": "Atchison",
    "NumberofStores": 83
  },
  {
    "State": "MO",
    "County": "Barton",
    "NumberofStores": 21
  },
  {
    "State": "MO",
    "County": "Bates",
    "NumberofStores": 57
  },
  {
    "State": "MO",
    "County": "Benton",
    "NumberofStores": 61
  },
  {
    "State": "MO",
    "County": "Boone",
    "NumberofStores": 83
  },
  {
    "State": "MO",
    "County": "Buchanan",
    "NumberofStores": 317
  },
  {
    "State": "MO",
    "County": "Caldwell",
    "NumberofStores": 197
  },
  {
    "State": "MO",
    "County": "Callaway",
    "NumberofStores": 137
  },
  {
    "State": "MO",
    "County": "Camden",
    "NumberofStores": 73
  },
  {
    "State": "MO",
    "County": "Carroll",
    "NumberofStores": 113
  },
  {
    "State": "MO",
    "County": "Cass",
    "NumberofStores": 97
  },
  {
    "State": "MO",
    "County": "Cedar",
    "NumberofStores": 41
  },
  {
    "State": "MO",
    "County": "Chariton",
    "NumberofStores": 83
  },
  {
    "State": "MO",
    "County": "Clay",
    "NumberofStores": 29
  },
  {
    "State": "MO",
    "County": "Clinton",
    "NumberofStores": 61
  },
  {
    "State": "MO",
    "County": "Cole",
    "NumberofStores": 197
  },
  {
    "State": "MO",
    "County": "Cooper",
    "NumberofStores": 53
  },
  {
    "State": "MO",
    "County": "Crawford",
    "NumberofStores": 127
  },
  {
    "State": "MO",
    "County": "Dade",
    "NumberofStores": 37
  },
  {
    "State": "MO",
    "County": "Daviess",
    "NumberofStores": 71
  },
  {
    "State": "MO",
    "County": "DeKalb",
    "NumberofStores": 43
  },
  {
    "State": "MO",
    "County": "Dent",
    "NumberofStores": 89
  },
  {
    "State": "MO",
    "County": "Franklin",
    "NumberofStores": 63
  },
  {
    "State": "MO",
    "County": "Gasconade",
    "NumberofStores": 47
  },
  {
    "State": "MO",
    "County": "Gentry",
    "NumberofStores": 97
  },
  {
    "State": "MO",
    "County": "Grundy",
    "NumberofStores": 317
  },
  {
    "State": "MO",
    "County": "Harrison",
    "NumberofStores": 197
  },
  {
    "State": "MO",
    "County": "Henry",
    "NumberofStores": 143
  },
  {
    "State": "MO",
    "County": "Hickory",
    "NumberofStores": 83
  },
  {
    "State": "MO",
    "County": "Holt",
    "NumberofStores": 117
  },
  {
    "State": "MO",
    "County": "Howard",
    "NumberofStores": 137
  },
  {
    "State": "MO",
    "County": "Jackson",
    "NumberofStores": 97
  },
  {
    "State": "MO",
    "County": "Jasper",
    "NumberofStores": 53
  },
  {
    "State": "MO",
    "County": "Johnson",
    "NumberofStores": 31
  },
  {
    "State": "MO",
    "County": "Laclede",
    "NumberofStores": 83
  },
  {
    "State": "MO",
    "County": "Lafayette",
    "NumberofStores": 61
  },
  {
    "State": "MO",
    "County": "Lincoln",
    "NumberofStores": 127
  },
  {
    "State": "MO",
    "County": "Linn",
    "NumberofStores": 29
  },
  {
    "State": "MO",
    "County": "Livingston",
    "NumberofStores": 113
  },
  {
    "State": "MO",
    "County": "Maries",
    "NumberofStores": 41
  },
  {
    "State": "MO",
    "County": "McDonald",
    "NumberofStores": 97
  },
  {
    "State": "MO",
    "County": "Mercer",
    "NumberofStores": 247
  },
  {
    "State": "MO",
    "County": "Miller",
    "NumberofStores": 83
  },
  {
    "State": "MO",
    "County": "Moniteau",
    "NumberofStores": 173
  },
  {
    "State": "MO",
    "County": "Montgomery",
    "NumberofStores": 137
  },
  {
    "State": "MO",
    "County": "Morgan",
    "NumberofStores": 29
  },
  {
    "State": "MO",
    "County": "Newton",
    "NumberofStores": 61
  },
  {
    "State": "MO",
    "County": "Nodaway",
    "NumberofStores": 89
  },
  {
    "State": "MO",
    "County": "Osage",
    "NumberofStores": 117
  },
  {
    "State": "MO",
    "County": "Pettis",
    "NumberofStores": 37
  },
  {
    "State": "MO",
    "County": "Phelps",
    "NumberofStores": 213
  },
  {
    "State": "MO",
    "County": "Platte",
    "NumberofStores": 73
  },
  {
    "State": "MO",
    "County": "Pulaski",
    "NumberofStores": 53
  },
  {
    "State": "MO",
    "County": "Putnam",
    "NumberofStores": 41
  },
  {
    "State": "MO",
    "County": "Ray",
    "NumberofStores": 19
  },
  {
    "State": "MO",
    "County": "Saline",
    "NumberofStores": 61
  },
  {
    "State": "MO",
    "County": "St. Charles",
    "NumberofStores": 143
  },
  {
    "State": "MO",
    "County": "St. Clair",
    "NumberofStores": 97
  },
  {
    "State": "MO",
    "County": "St. Louis",
    "NumberofStores": 197
  },
  {
    "State": "MO",
    "County": "St. Louis city",
    "NumberofStores": 83
  },
  {
    "State": "MO",
    "County": "Sullivan",
    "NumberofStores": 127
  },
  {
    "State": "MO",
    "County": "Vernon",
    "NumberofStores": 41
  },
  {
    "State": "MO",
    "County": "Warren",
    "NumberofStores": 29
  },
  {
    "State": "MO",
    "County": "Worth",
    "NumberofStores": 73
  },
  {
    "State": "ND",
    "County": "Burleigh",
    "NumberofStores": 317
  },
  {
    "State": "ND",
    "County": "Cass",
    "NumberofStores": 37
  },
  {
    "State": "ND",
    "County": "Dickey",
    "NumberofStores": 97
  },
  {
    "State": "ND",
    "County": "Emmons",
    "NumberofStores": 53
  },
  {
    "State": "ND",
    "County": "Grand Forks",
    "NumberofStores": 41
  },
  {
    "State": "ND",
    "County": "Kidder",
    "NumberofStores": 61
  },
  {
    "State": "ND",
    "County": "LaMoure",
    "NumberofStores": 137
  },
  {
    "State": "ND",
    "County": "Logan",
    "NumberofStores": 83
  },
  {
    "State": "ND",
    "County": "McIntosh",
    "NumberofStores": 29
  },
  {
    "State": "ND",
    "County": "McLean",
    "NumberofStores": 113
  },
  {
    "State": "ND",
    "County": "Morton",
    "NumberofStores": 197
  },
  {
    "State": "ND",
    "County": "Oliver",
    "NumberofStores": 97
  },
  {
    "State": "ND",
    "County": "Richland",
    "NumberofStores": 247
  },
  {
    "State": "ND",
    "County": "Sargent",
    "NumberofStores": 173
  },
  {
    "State": "ND",
    "County": "Sheridan",
    "NumberofStores": 29
  },
  {
    "State": "ND",
    "County": "Sioux",
    "NumberofStores": 19
  },
  {
    "State": "ND",
    "County": "Towner",
    "NumberofStores": 213
  },
  {
    "State": "ND",
    "County": "Traill",
    "NumberofStores": 41
  },
  {
    "State": "NE",
    "County": "Burt",
    "NumberofStores": 83
  },
  {
    "State": "NE",
    "County": "Butler",
    "NumberofStores": 73
  },
  {
    "State": "NE",
    "County": "Cass",
    "NumberofStores": 137
  },
  {
    "State": "NE",
    "County": "Cedar",
    "NumberofStores": 29
  },
  {
    "State": "NE",
    "County": "Colfax",
    "NumberofStores": 173
  },
  {
    "State": "NE",
    "County": "Cuming",
    "NumberofStores": 41
  },
  {
    "State": "NE",
    "County": "Dakota",
    "NumberofStores": 61
  },
  {
    "State": "NE",
    "County": "Dixon",
    "NumberofStores": 113
  },
  {
    "State": "NE",
    "County": "Dodge",
    "NumberofStores": 29
  },
  {
    "State": "NE",
    "County": "Douglas",
    "NumberofStores": 97
  },
  {
    "State": "NE",
    "County": "Gage",
    "NumberofStores": 247
  },
  {
    "State": "NE",
    "County": "Jefferson",
    "NumberofStores": 83
  },
  {
    "State": "NE",
    "County": "Johnson",
    "NumberofStores": 137
  },
  {
    "State": "NE",
    "County": "Lancaster",
    "NumberofStores": 213
  },
  {
    "State": "NE",
    "County": "Madison",
    "NumberofStores": 73
  },
  {
    "State": "NE",
    "County": "Nemaha",
    "NumberofStores": 29
  },
  {
    "State": "NE",
    "County": "Otoe",
    "NumberofStores": 163
  },
  {
    "State": "NE",
    "County": "Pawnee",
    "NumberofStores": 47
  },
  {
    "State": "NE",
    "County": "Pierce",
    "NumberofStores": 97
  },
  {
    "State": "NE",
    "County": "Platte",
    "NumberofStores": 213
  },
  {
    "State": "NE",
    "County": "Richardson",
    "NumberofStores": 37
  },
  {
    "State": "NE",
    "County": "Saline",
    "NumberofStores": 61
  },
  {
    "State": "NE",
    "County": "Sarpy",
    "NumberofStores": 127
  },
  {
    "State": "NE",
    "County": "Saunders",
    "NumberofStores": 173
  },
  {
    "State": "NE",
    "County": "Seward",
    "NumberofStores": 83
  },
  {
    "State": "NE",
    "County": "Stanton",
    "NumberofStores": 41
  },
  {
    "State": "NE",
    "County": "Thurston",
    "NumberofStores": 29
  },
  {
    "State": "NE",
    "County": "Washington",
    "NumberofStores": 97
  },
  {
    "State": "NE",
    "County": "Wayne",
    "NumberofStores": 163
  },
  {
    "State": "NM",
    "County": "Bernalillo",
    "NumberofStores": 73
  },
  {
    "State": "NM",
    "County": "Catron",
    "NumberofStores": 113
  },
  {
    "State": "NM",
    "County": "Cibola",
    "NumberofStores": 247
  },
  {
    "State": "NM",
    "County": "Colfax",
    "NumberofStores": 83
  },
  {
    "State": "NM",
    "County": "Harding",
    "NumberofStores": 61
  },
  {
    "State": "NM",
    "County": "Los Alamos",
    "NumberofStores": 197
  },
  {
    "State": "NM",
    "County": "McKinley",
    "NumberofStores": 127
  },
  {
    "State": "NM",
    "County": "Mora",
    "NumberofStores": 37
  },
  {
    "State": "NM",
    "County": "Rio Arriba County",
    "NumberofStores": 29
  },
  {
    "State": "NM",
    "County": "San Miguel",
    "NumberofStores": 113
  },
  {
    "State": "NM",
    "County": "Sandoval",
    "NumberofStores": 83
  },
  {
    "State": "NM",
    "County": "Santa Fe",
    "NumberofStores": 173
  },
  {
    "State": "NM",
    "County": "Socorro",
    "NumberofStores": 47
  },
  {
    "State": "NM",
    "County": "Taos",
    "NumberofStores": 61
  },
  {
    "State": "NM",
    "County": "Torrance",
    "NumberofStores": 97
  },
  {
    "State": "NM",
    "County": "Union",
    "NumberofStores": 213
  },
  {
    "State": "NM",
    "County": "Valencia",
    "NumberofStores": 41
  },
  {
    "State": "NV",
    "County": "Carson City",
    "NumberofStores": 29
  },
  {
    "State": "NV",
    "County": "Churchill County",
    "NumberofStores": 127
  },
  {
    "State": "NV",
    "County": "Clark",
    "NumberofStores": 83
  },
  {
    "State": "NV",
    "County": "Douglas County",
    "NumberofStores": 83
  },
  {
    "State": "NV",
    "County": "Lincoln",
    "NumberofStores": 29
  },
  {
    "State": "NV",
    "County": "Lyon County",
    "NumberofStores": 117
  },
  {
    "State": "NV",
    "County": "Mineral County",
    "NumberofStores": 21
  },
  {
    "State": "NV",
    "County": "Nye",
    "NumberofStores": 137
  },
  {
    "State": "NV",
    "County": "Storey County",
    "NumberofStores": 17
  },
  {
    "State": "NV",
    "County": "Washoe County",
    "NumberofStores": 487
  },
  {
    "State": "OH",
    "County": "Adams",
    "NumberofStores": 43
  },
  {
    "State": "OH",
    "County": "Allen",
    "NumberofStores": 173
  },
  {
    "State": "OH",
    "County": "Ashland",
    "NumberofStores": 83
  },
  {
    "State": "OH",
    "County": "Ashtabula",
    "NumberofStores": 127
  },
  {
    "State": "OH",
    "County": "Athens",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Auglaize",
    "NumberofStores": 61
  },
  {
    "State": "OH",
    "County": "Belmont",
    "NumberofStores": 89
  },
  {
    "State": "OH",
    "County": "Brown",
    "NumberofStores": 117
  },
  {
    "State": "OH",
    "County": "Butler",
    "NumberofStores": 73
  },
  {
    "State": "OH",
    "County": "Carroll",
    "NumberofStores": 397
  },
  {
    "State": "OH",
    "County": "Champaign",
    "NumberofStores": 47
  },
  {
    "State": "OH",
    "County": "Clark",
    "NumberofStores": 71
  },
  {
    "State": "OH",
    "County": "Clermont",
    "NumberofStores": 113
  },
  {
    "State": "OH",
    "County": "Clinton",
    "NumberofStores": 163
  },
  {
    "State": "OH",
    "County": "Columbiana",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Coshocton",
    "NumberofStores": 123
  },
  {
    "State": "OH",
    "County": "Crawford",
    "NumberofStores": 57
  },
  {
    "State": "OH",
    "County": "Cuyahoga",
    "NumberofStores": 913
  },
  {
    "State": "OH",
    "County": "Darke",
    "NumberofStores": 41
  },
  {
    "State": "OH",
    "County": "Defiance",
    "NumberofStores": 37
  },
  {
    "State": "OH",
    "County": "Delaware",
    "NumberofStores": 127
  },
  {
    "State": "OH",
    "County": "Erie",
    "NumberofStores": 173
  },
  {
    "State": "OH",
    "County": "Fairfield",
    "NumberofStores": 83
  },
  {
    "State": "OH",
    "County": "Fayette",
    "NumberofStores": 487
  },
  {
    "State": "OH",
    "County": "Franklin",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Fulton",
    "NumberofStores": 53
  },
  {
    "State": "OH",
    "County": "Gallia",
    "NumberofStores": 29
  },
  {
    "State": "OH",
    "County": "Geauga",
    "NumberofStores": 43
  },
  {
    "State": "OH",
    "County": "Greene",
    "NumberofStores": 61
  },
  {
    "State": "OH",
    "County": "Guernsey",
    "NumberofStores": 47
  },
  {
    "State": "OH",
    "County": "Hamilton",
    "NumberofStores": 31
  },
  {
    "State": "OH",
    "County": "Hancock",
    "NumberofStores": 73
  },
  {
    "State": "OH",
    "County": "Hardin",
    "NumberofStores": 53
  },
  {
    "State": "OH",
    "County": "Harrison",
    "NumberofStores": 41
  },
  {
    "State": "OH",
    "County": "Henry",
    "NumberofStores": 79
  },
  {
    "State": "OH",
    "County": "Highland",
    "NumberofStores": 137
  },
  {
    "State": "OH",
    "County": "Hocking",
    "NumberofStores": 83
  },
  {
    "State": "OH",
    "County": "Holmes",
    "NumberofStores": 213
  },
  {
    "State": "OH",
    "County": "Huron",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Jackson",
    "NumberofStores": 247
  },
  {
    "State": "OH",
    "County": "Jefferson",
    "NumberofStores": 83
  },
  {
    "State": "OH",
    "County": "Knox",
    "NumberofStores": 41
  },
  {
    "State": "OH",
    "County": "Lake",
    "NumberofStores": 173
  },
  {
    "State": "OH",
    "County": "Lawrence",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Licking",
    "NumberofStores": 163
  },
  {
    "State": "OH",
    "County": "Logan",
    "NumberofStores": 29
  },
  {
    "State": "OH",
    "County": "Lorain",
    "NumberofStores": 73
  },
  {
    "State": "OH",
    "County": "Lucas",
    "NumberofStores": 127
  },
  {
    "State": "OH",
    "County": "Madison",
    "NumberofStores": 21
  },
  {
    "State": "OH",
    "County": "Mahoning",
    "NumberofStores": 413
  },
  {
    "State": "OH",
    "County": "Marion",
    "NumberofStores": 37
  },
  {
    "State": "OH",
    "County": "Medina",
    "NumberofStores": 53
  },
  {
    "State": "OH",
    "County": "Meigs",
    "NumberofStores": 117
  },
  {
    "State": "OH",
    "County": "Mercer",
    "NumberofStores": 29
  },
  {
    "State": "OH",
    "County": "Miami",
    "NumberofStores": 61
  },
  {
    "State": "OH",
    "County": "Monroe",
    "NumberofStores": 19
  },
  {
    "State": "OH",
    "County": "Montgomery",
    "NumberofStores": 47
  },
  {
    "State": "OH",
    "County": "Morgan",
    "NumberofStores": 137
  },
  {
    "State": "OH",
    "County": "Morrow",
    "NumberofStores": 29
  },
  {
    "State": "OH",
    "County": "Muskingum",
    "NumberofStores": 83
  },
  {
    "State": "OH",
    "County": "Noble",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Ottawa",
    "NumberofStores": 31
  },
  {
    "State": "OH",
    "County": "Paulding",
    "NumberofStores": 183
  },
  {
    "State": "OH",
    "County": "Perry",
    "NumberofStores": 53
  },
  {
    "State": "OH",
    "County": "Pickaway",
    "NumberofStores": 29
  },
  {
    "State": "OH",
    "County": "Pike",
    "NumberofStores": 113
  },
  {
    "State": "OH",
    "County": "Portage",
    "NumberofStores": 167
  },
  {
    "State": "OH",
    "County": "Preble",
    "NumberofStores": 79
  },
  {
    "State": "OH",
    "County": "Putnam",
    "NumberofStores": 213
  },
  {
    "State": "OH",
    "County": "Richland",
    "NumberofStores": 197
  },
  {
    "State": "OH",
    "County": "Ross",
    "NumberofStores": 163
  },
  {
    "State": "OH",
    "County": "Sandusky",
    "NumberofStores": 137
  },
  {
    "State": "OH",
    "County": "Scioto",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Seneca",
    "NumberofStores": 61
  },
  {
    "State": "OH",
    "County": "Shelby",
    "NumberofStores": 29
  },
  {
    "State": "OH",
    "County": "Stark",
    "NumberofStores": 11
  },
  {
    "State": "OH",
    "County": "Summit",
    "NumberofStores": 173
  },
  {
    "State": "OH",
    "County": "Trumbull",
    "NumberofStores": 73
  },
  {
    "State": "OH",
    "County": "Tuscarawas",
    "NumberofStores": 97
  },
  {
    "State": "OH",
    "County": "Union",
    "NumberofStores": 41
  },
  {
    "State": "OH",
    "County": "Van Wert",
    "NumberofStores": 83
  },
  {
    "State": "OH",
    "County": "Vinton",
    "NumberofStores": 29
  },
  {
    "State": "OH",
    "County": "Warren",
    "NumberofStores": 47
  },
  {
    "State": "OH",
    "County": "Washington",
    "NumberofStores": 17
  },
  {
    "State": "OH",
    "County": "Wayne",
    "NumberofStores": 19
  },
  {
    "State": "OH",
    "County": "Williams",
    "NumberofStores": 41
  },
  {
    "State": "OH",
    "County": "Wood",
    "NumberofStores": 11
  },
  {
    "State": "OH",
    "County": "Wyandot",
    "NumberofStores": 73
  },
  {
    "State": "OK",
    "County": "Adair",
    "NumberofStores": 47
  },
  {
    "State": "OK",
    "County": "Alfalfa",
    "NumberofStores": 83
  },
  {
    "State": "OK",
    "County": "Atoka",
    "NumberofStores": 127
  },
  {
    "State": "OK",
    "County": "Beaver",
    "NumberofStores": 61
  },
  {
    "State": "OK",
    "County": "Beckham",
    "NumberofStores": 113
  },
  {
    "State": "OK",
    "County": "Blaine",
    "NumberofStores": 37
  },
  {
    "State": "OK",
    "County": "Bryan",
    "NumberofStores": 173
  },
  {
    "State": "OK",
    "County": "Caddo",
    "NumberofStores": 23
  },
  {
    "State": "OK",
    "County": "Canadian",
    "NumberofStores": 137
  },
  {
    "State": "OK",
    "County": "Carter",
    "NumberofStores": 17
  },
  {
    "State": "OK",
    "County": "Cherokee",
    "NumberofStores": 41
  },
  {
    "State": "OK",
    "County": "Choctaw",
    "NumberofStores": 97
  },
  {
    "State": "OK",
    "County": "Cimarron",
    "NumberofStores": 31
  },
  {
    "State": "OK",
    "County": "Cleveland",
    "NumberofStores": 11
  },
  {
    "State": "OK",
    "County": "Coal",
    "NumberofStores": 347
  },
  {
    "State": "OK",
    "County": "Comanche",
    "NumberofStores": 19
  },
  {
    "State": "OK",
    "County": "Cotton",
    "NumberofStores": 113
  },
  {
    "State": "OK",
    "County": "Craig",
    "NumberofStores": 29
  },
  {
    "State": "OK",
    "County": "Creek",
    "NumberofStores": 47
  },
  {
    "State": "OK",
    "County": "Custer",
    "NumberofStores": 83
  },
  {
    "State": "OK",
    "County": "Delaware",
    "NumberofStores": 17
  },
  {
    "State": "OK",
    "County": "Dewey",
    "NumberofStores": 29
  },
  {
    "State": "OK",
    "County": "Ellis",
    "NumberofStores": 137
  },
  {
    "State": "OK",
    "County": "Garfield",
    "NumberofStores": 197
  },
  {
    "State": "OK",
    "County": "Garvin",
    "NumberofStores": 23
  },
  {
    "State": "OK",
    "County": "Grady",
    "NumberofStores": 61
  },
  {
    "State": "OK",
    "County": "Grant",
    "NumberofStores": 29
  },
  {
    "State": "OK",
    "County": "Greer",
    "NumberofStores": 97
  },
  {
    "State": "OK",
    "County": "Harmon",
    "NumberofStores": 53
  },
  {
    "State": "OK",
    "County": "Harper",
    "NumberofStores": 19
  },
  {
    "State": "OK",
    "County": "Haskell",
    "NumberofStores": 113
  },
  {
    "State": "OK",
    "County": "Hughes",
    "NumberofStores": 31
  },
  {
    "State": "OK",
    "County": "Jackson",
    "NumberofStores": 83
  },
  {
    "State": "OK",
    "County": "Jefferson",
    "NumberofStores": 173
  },
  {
    "State": "OK",
    "County": "Johnston",
    "NumberofStores": 47
  },
  {
    "State": "OK",
    "County": "Kay",
    "NumberofStores": 19
  },
  {
    "State": "OK",
    "County": "Kingfisher",
    "NumberofStores": 137
  },
  {
    "State": "OK",
    "County": "Kiowa",
    "NumberofStores": 97
  },
  {
    "State": "OK",
    "County": "Latimer",
    "NumberofStores": 61
  },
  {
    "State": "OK",
    "County": "Le Flore",
    "NumberofStores": 29
  },
  {
    "State": "OK",
    "County": "Lincoln",
    "NumberofStores": 113
  },
  {
    "State": "OK",
    "County": "Logan",
    "NumberofStores": 197
  },
  {
    "State": "OK",
    "County": "Love",
    "NumberofStores": 83
  },
  {
    "State": "OK",
    "County": "Major",
    "NumberofStores": 53
  },
  {
    "State": "OK",
    "County": "Marshall",
    "NumberofStores": 137
  },
  {
    "State": "OK",
    "County": "Mayes",
    "NumberofStores": 41
  },
  {
    "State": "OK",
    "County": "McClain",
    "NumberofStores": 97
  },
  {
    "State": "OK",
    "County": "McCurtain",
    "NumberofStores": 23
  },
  {
    "State": "OK",
    "County": "McIntosh",
    "NumberofStores": 173
  },
  {
    "State": "OK",
    "County": "Murray",
    "NumberofStores": 31
  },
  {
    "State": "OK",
    "County": "Muskogee",
    "NumberofStores": 83
  },
  {
    "State": "OK",
    "County": "Noble",
    "NumberofStores": 29
  },
  {
    "State": "OK",
    "County": "Nowata",
    "NumberofStores": 137
  },
  {
    "State": "OK",
    "County": "Okfuskee",
    "NumberofStores": 197
  },
  {
    "State": "OK",
    "County": "Oklahoma",
    "NumberofStores": 53
  },
  {
    "State": "OK",
    "County": "Okmulgee",
    "NumberofStores": 19
  },
  {
    "State": "OK",
    "County": "Osage",
    "NumberofStores": 347
  },
  {
    "State": "OK",
    "County": "Ottawa",
    "NumberofStores": 73
  },
  {
    "State": "OK",
    "County": "Pawnee",
    "NumberofStores": 97
  },
  {
    "State": "OK",
    "County": "Payne",
    "NumberofStores": 29
  },
  {
    "State": "OK",
    "County": "Pittsburg",
    "NumberofStores": 41
  },
  {
    "State": "OK",
    "County": "Pontotoc",
    "NumberofStores": 137
  },
  {
    "State": "OK",
    "County": "Pottawatomie",
    "NumberofStores": 131
  },
  {
    "State": "OK",
    "County": "Pushmataha",
    "NumberofStores": 29
  },
  {
    "State": "OK",
    "County": "Roger Mills",
    "NumberofStores": 17
  },
  {
    "State": "OK",
    "County": "Rogers",
    "NumberofStores": 173
  },
  {
    "State": "OK",
    "County": "Seminole",
    "NumberofStores": 83
  },
  {
    "State": "OK",
    "County": "Stephens",
    "NumberofStores": 137
  },
  {
    "State": "OK",
    "County": "Texas",
    "NumberofStores": 41
  },
  {
    "State": "OK",
    "County": "Tillman",
    "NumberofStores": 53
  },
  {
    "State": "OK",
    "County": "Tulsa",
    "NumberofStores": 913
  },
  {
    "State": "OK",
    "County": "Wagoner",
    "NumberofStores": 127
  },
  {
    "State": "OK",
    "County": "Washington",
    "NumberofStores": 97
  },
  {
    "State": "OK",
    "County": "Washita",
    "NumberofStores": 43
  },
  {
    "State": "OK",
    "County": "Woods",
    "NumberofStores": 61
  },
  {
    "State": "OK",
    "County": "Woodward",
    "NumberofStores": 117
  },
  {
    "State": "PA",
    "County": "Allegheny",
    "NumberofStores": 947
  },
  {
    "State": "PA",
    "County": "Armstrong",
    "NumberofStores": 83
  },
  {
    "State": "PA",
    "County": "Beaver",
    "NumberofStores": 197
  },
  {
    "State": "PA",
    "County": "Berks",
    "NumberofStores": 613
  },
  {
    "State": "PA",
    "County": "Butler",
    "NumberofStores": 287
  },
  {
    "State": "PA",
    "County": "Carbon",
    "NumberofStores": 73
  },
  {
    "State": "PA",
    "County": "Centre",
    "NumberofStores": 173
  },
  {
    "State": "PA",
    "County": "Clinton",
    "NumberofStores": 61
  },
  {
    "State": "PA",
    "County": "Columbia",
    "NumberofStores": 97
  },
  {
    "State": "PA",
    "County": "Crawford",
    "NumberofStores": 83
  },
  {
    "State": "PA",
    "County": "Dauphin",
    "NumberofStores": 247
  },
  {
    "State": "PA",
    "County": "Erie",
    "NumberofStores": 71
  },
  {
    "State": "PA",
    "County": "Indiana",
    "NumberofStores": 113
  },
  {
    "State": "PA",
    "County": "Juniata",
    "NumberofStores": 197
  },
  {
    "State": "PA",
    "County": "Lancaster",
    "NumberofStores": 137
  },
  {
    "State": "PA",
    "County": "Lawrence",
    "NumberofStores": 83
  },
  {
    "State": "PA",
    "County": "Lebanon",
    "NumberofStores": 317
  },
  {
    "State": "PA",
    "County": "Lehigh",
    "NumberofStores": 347
  },
  {
    "State": "PA",
    "County": "Lycoming",
    "NumberofStores": 397
  },
  {
    "State": "PA",
    "County": "Mercer",
    "NumberofStores": 97
  },
  {
    "State": "PA",
    "County": "Mifflin",
    "NumberofStores": 29
  },
  {
    "State": "PA",
    "County": "Montour",
    "NumberofStores": 113
  },
  {
    "State": "PA",
    "County": "Northampton",
    "NumberofStores": 173
  },
  {
    "State": "PA",
    "County": "Northumberland",
    "NumberofStores": 137
  },
  {
    "State": "PA",
    "County": "Perry",
    "NumberofStores": 31
  },
  {
    "State": "PA",
    "County": "Schuylkill",
    "NumberofStores": 213
  },
  {
    "State": "PA",
    "County": "Snyder",
    "NumberofStores": 83
  },
  {
    "State": "PA",
    "County": "Union",
    "NumberofStores": 41
  },
  {
    "State": "PA",
    "County": "Venango",
    "NumberofStores": 29
  },
  {
    "State": "PA",
    "County": "Washington",
    "NumberofStores": 61
  },
  {
    "State": "PA",
    "County": "Westmoreland",
    "NumberofStores": 47
  },
  {
    "State": "PA",
    "County": "York",
    "NumberofStores": 37
  },
  {
    "State": "SD",
    "County": "Beadle",
    "NumberofStores": 19
  },
  {
    "State": "SD",
    "County": "Bon Homme",
    "NumberofStores": 27
  },
  {
    "State": "SD",
    "County": "Brookings",
    "NumberofStores": 23
  },
  {
    "State": "SD",
    "County": "Brown",
    "NumberofStores": 29
  },
  {
    "State": "SD",
    "County": "Clark",
    "NumberofStores": 17
  },
  {
    "State": "SD",
    "County": "Clay",
    "NumberofStores": 41
  },
  {
    "State": "SD",
    "County": "Davison",
    "NumberofStores": 31
  },
  {
    "State": "SD",
    "County": "Day",
    "NumberofStores": 29
  },
  {
    "State": "SD",
    "County": "Douglas",
    "NumberofStores": 197
  },
  {
    "State": "SD",
    "County": "Edmunds County",
    "NumberofStores": 43
  },
  {
    "State": "SD",
    "County": "Faulk County",
    "NumberofStores": 17
  },
  {
    "State": "SD",
    "County": "Hand County",
    "NumberofStores": 47
  },
  {
    "State": "SD",
    "County": "Hanson",
    "NumberofStores": 73
  },
  {
    "State": "SD",
    "County": "Hutchinson",
    "NumberofStores": 317
  },
  {
    "State": "SD",
    "County": "Jerauld",
    "NumberofStores": 61
  },
  {
    "State": "SD",
    "County": "Kingsbury",
    "NumberofStores": 29
  },
  {
    "State": "SD",
    "County": "Lake",
    "NumberofStores": 17
  },
  {
    "State": "SD",
    "County": "Lincoln",
    "NumberofStores": 23
  },
  {
    "State": "SD",
    "County": "Marshall",
    "NumberofStores": 413
  },
  {
    "State": "SD",
    "County": "McCook",
    "NumberofStores": 61
  },
  {
    "State": "SD",
    "County": "McPherson County",
    "NumberofStores": 29
  },
  {
    "State": "SD",
    "County": "Miner",
    "NumberofStores": 83
  },
  {
    "State": "SD",
    "County": "Minnehaha",
    "NumberofStores": 127
  },
  {
    "State": "SD",
    "County": "Moody",
    "NumberofStores": 213
  },
  {
    "State": "SD",
    "County": "Sanborn",
    "NumberofStores": 47
  },
  {
    "State": "SD",
    "County": "Spink",
    "NumberofStores": 83
  },
  {
    "State": "SD",
    "County": "Turner",
    "NumberofStores": 97
  },
  {
    "State": "SD",
    "County": "Union",
    "NumberofStores": 113
  },
  {
    "State": "SD",
    "County": "Yankton",
    "NumberofStores": 163
  },
  {
    "State": "TN",
    "County": "Anderson",
    "NumberofStores": 317
  },
  {
    "State": "TN",
    "County": "Blount",
    "NumberofStores": 21
  },
  {
    "State": "TN",
    "County": "Bradley County",
    "NumberofStores": 97
  },
  {
    "State": "TN",
    "County": "Campbell",
    "NumberofStores": 83
  },
  {
    "State": "TN",
    "County": "Carter",
    "NumberofStores": 117
  },
  {
    "State": "TN",
    "County": "Cheatham County",
    "NumberofStores": 173
  },
  {
    "State": "TN",
    "County": "Chester County",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Claiborne",
    "NumberofStores": 137
  },
  {
    "State": "TN",
    "County": "Clay",
    "NumberofStores": 113
  },
  {
    "State": "TN",
    "County": "Cocke",
    "NumberofStores": 41
  },
  {
    "State": "TN",
    "County": "Cumberland",
    "NumberofStores": 19
  },
  {
    "State": "TN",
    "County": "Davidson County",
    "NumberofStores": 53
  },
  {
    "State": "TN",
    "County": "Decatur County",
    "NumberofStores": 61
  },
  {
    "State": "TN",
    "County": "Dickson",
    "NumberofStores": 173
  },
  {
    "State": "TN",
    "County": "Fayette County",
    "NumberofStores": 47
  },
  {
    "State": "TN",
    "County": "Fentress",
    "NumberofStores": 83
  },
  {
    "State": "TN",
    "County": "Gibson County",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Grainger",
    "NumberofStores": 197
  },
  {
    "State": "TN",
    "County": "Greene",
    "NumberofStores": 127
  },
  {
    "State": "TN",
    "County": "Hamblen",
    "NumberofStores": 73
  },
  {
    "State": "TN",
    "County": "Hamilton",
    "NumberofStores": 213
  },
  {
    "State": "TN",
    "County": "Hancock",
    "NumberofStores": 913
  },
  {
    "State": "TN",
    "County": "Hardeman County",
    "NumberofStores": 53
  },
  {
    "State": "TN",
    "County": "Hardin County",
    "NumberofStores": 37
  },
  {
    "State": "TN",
    "County": "Hawkins",
    "NumberofStores": 167
  },
  {
    "State": "TN",
    "County": "Haywood County",
    "NumberofStores": 347
  },
  {
    "State": "TN",
    "County": "Henderson County",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Henry",
    "NumberofStores": 61
  },
  {
    "State": "TN",
    "County": "Houston",
    "NumberofStores": 213
  },
  {
    "State": "TN",
    "County": "Humphreys",
    "NumberofStores": 137
  },
  {
    "State": "TN",
    "County": "Jackson",
    "NumberofStores": 83
  },
  {
    "State": "TN",
    "County": "Jefferson",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Johnson",
    "NumberofStores": 73
  },
  {
    "State": "TN",
    "County": "Knox",
    "NumberofStores": 97
  },
  {
    "State": "TN",
    "County": "Loudon",
    "NumberofStores": 197
  },
  {
    "State": "TN",
    "County": "Macon",
    "NumberofStores": 163
  },
  {
    "State": "TN",
    "County": "Madison County",
    "NumberofStores": 113
  },
  {
    "State": "TN",
    "County": "McMinn",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "McNairy",
    "NumberofStores": 41
  },
  {
    "State": "TN",
    "County": "Meigs",
    "NumberofStores": 213
  },
  {
    "State": "TN",
    "County": "Monroe",
    "NumberofStores": 83
  },
  {
    "State": "TN",
    "County": "Morgan",
    "NumberofStores": 61
  },
  {
    "State": "TN",
    "County": "Obion",
    "NumberofStores": 347
  },
  {
    "State": "TN",
    "County": "Overton",
    "NumberofStores": 113
  },
  {
    "State": "TN",
    "County": "Pickett",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Polk",
    "NumberofStores": 173
  },
  {
    "State": "TN",
    "County": "Putnam",
    "NumberofStores": 83
  },
  {
    "State": "TN",
    "County": "Rhea",
    "NumberofStores": 197
  },
  {
    "State": "TN",
    "County": "Roane",
    "NumberofStores": 73
  },
  {
    "State": "TN",
    "County": "Robertson",
    "NumberofStores": 137
  },
  {
    "State": "TN",
    "County": "Rutherford County",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Scott",
    "NumberofStores": 61
  },
  {
    "State": "TN",
    "County": "Sevier",
    "NumberofStores": 83
  },
  {
    "State": "TN",
    "County": "Shelby",
    "NumberofStores": 197
  },
  {
    "State": "TN",
    "County": "Smith",
    "NumberofStores": 113
  },
  {
    "State": "TN",
    "County": "Stewart",
    "NumberofStores": 173
  },
  {
    "State": "TN",
    "County": "Sullivan",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Sumner",
    "NumberofStores": 61
  },
  {
    "State": "TN",
    "County": "Trousdale County",
    "NumberofStores": 83
  },
  {
    "State": "TN",
    "County": "Unicoi",
    "NumberofStores": 247
  },
  {
    "State": "TN",
    "County": "Union",
    "NumberofStores": 127
  },
  {
    "State": "TN",
    "County": "Washington",
    "NumberofStores": 29
  },
  {
    "State": "TN",
    "County": "Weakley",
    "NumberofStores": 137
  },
  {
    "State": "TN",
    "County": "Wilson County",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Andrews",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Angelina",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Aransas",
    "NumberofStores": 347
  },
  {
    "State": "TX",
    "County": "Archer",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "Armstrong",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Atascosa",
    "NumberofStores": 73
  },
  {
    "State": "TX",
    "County": "Austin",
    "NumberofStores": 117
  },
  {
    "State": "TX",
    "County": "Bailey",
    "NumberofStores": 913
  },
  {
    "State": "TX",
    "County": "Bandera",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Bastrop",
    "NumberofStores": 143
  },
  {
    "State": "TX",
    "County": "Baylor",
    "NumberofStores": 17
  },
  {
    "State": "TX",
    "County": "Bee",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Bell",
    "NumberofStores": 247
  },
  {
    "State": "TX",
    "County": "Bexar",
    "NumberofStores": 1187
  },
  {
    "State": "TX",
    "County": "Blanco",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Borden",
    "NumberofStores": 3
  },
  {
    "State": "TX",
    "County": "Bosque",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Bowie",
    "NumberofStores": 183
  },
  {
    "State": "TX",
    "County": "Brazoria",
    "NumberofStores": 327
  },
  {
    "State": "TX",
    "County": "Brazos",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Brewster",
    "NumberofStores": 23
  },
  {
    "State": "TX",
    "County": "Briscoe",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Brooks",
    "NumberofStores": 27
  },
  {
    "State": "TX",
    "County": "Burleson",
    "NumberofStores": 73
  },
  {
    "State": "TX",
    "County": "Burnet",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Caldwell",
    "NumberofStores": 113
  },
  {
    "State": "TX",
    "County": "Calhoun",
    "NumberofStores": 47
  },
  {
    "State": "TX",
    "County": "Cameron",
    "NumberofStores": 413
  },
  {
    "State": "TX",
    "County": "Camp",
    "NumberofStores": 31
  },
  {
    "State": "TX",
    "County": "Carson",
    "NumberofStores": 23
  },
  {
    "State": "TX",
    "County": "Cass",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Castro",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Chambers",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Childress",
    "NumberofStores": 21
  },
  {
    "State": "TX",
    "County": "Clay",
    "NumberofStores": 43
  },
  {
    "State": "TX",
    "County": "Cochran",
    "NumberofStores": 7
  },
  {
    "State": "TX",
    "County": "Coke",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Collin",
    "NumberofStores": 937
  },
  {
    "State": "TX",
    "County": "Collingsworth",
    "NumberofStores": 9
  },
  {
    "State": "TX",
    "County": "Colorado",
    "NumberofStores": 73
  },
  {
    "State": "TX",
    "County": "Comal",
    "NumberofStores": 213
  },
  {
    "State": "TX",
    "County": "Comanche",
    "NumberofStores": 37
  },
  {
    "State": "TX",
    "County": "Concho",
    "NumberofStores": 13
  },
  {
    "State": "TX",
    "County": "Cooke",
    "NumberofStores": 89
  },
  {
    "State": "TX",
    "County": "Coryell",
    "NumberofStores": 127
  },
  {
    "State": "TX",
    "County": "Cottle",
    "NumberofStores": 7
  },
  {
    "State": "TX",
    "County": "Crane",
    "NumberofStores": 9
  },
  {
    "State": "TX",
    "County": "Crockett",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Crosby",
    "NumberofStores": 19
  },
  {
    "State": "TX",
    "County": "Dallam",
    "NumberofStores": 13
  },
  {
    "State": "TX",
    "County": "Dallas",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Dawson",
    "NumberofStores": 1627
  },
  {
    "State": "TX",
    "County": "Deaf Smith",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Delta",
    "NumberofStores": 67
  },
  {
    "State": "TX",
    "County": "Denton",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "DeWitt",
    "NumberofStores": 987
  },
  {
    "State": "TX",
    "County": "Dickens",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "Dimmit",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Donley",
    "NumberofStores": 33
  },
  {
    "State": "TX",
    "County": "Duval",
    "NumberofStores": 19
  },
  {
    "State": "TX",
    "County": "Eastland",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Ector",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Edwards",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Ellis",
    "NumberofStores": 13
  },
  {
    "State": "TX",
    "County": "Erath",
    "NumberofStores": 287
  },
  {
    "State": "TX",
    "County": "Falls",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Fannin",
    "NumberofStores": 47
  },
  {
    "State": "TX",
    "County": "Fayette",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Floyd",
    "NumberofStores": 79
  },
  {
    "State": "TX",
    "County": "Foard",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Fort Bend",
    "NumberofStores": 7
  },
  {
    "State": "TX",
    "County": "Franklin",
    "NumberofStores": 1317
  },
  {
    "State": "TX",
    "County": "Freestone",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Frio",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "Galveston",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Garza",
    "NumberofStores": 317
  },
  {
    "State": "TX",
    "County": "Glasscock",
    "NumberofStores": 9
  },
  {
    "State": "TX",
    "County": "Goliad",
    "NumberofStores": 5
  },
  {
    "State": "TX",
    "County": "Gonzales",
    "NumberofStores": 23
  },
  {
    "State": "TX",
    "County": "Gray",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Grayson",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Gregg",
    "NumberofStores": 213
  },
  {
    "State": "TX",
    "County": "Grimes",
    "NumberofStores": 247
  },
  {
    "State": "TX",
    "County": "Guadalupe",
    "NumberofStores": 183
  },
  {
    "State": "TX",
    "County": "Hale",
    "NumberofStores": 73
  },
  {
    "State": "TX",
    "County": "Hall",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Hamilton",
    "NumberofStores": 47
  },
  {
    "State": "TX",
    "County": "Hansford",
    "NumberofStores": 19
  },
  {
    "State": "TX",
    "County": "Hardeman",
    "NumberofStores": 37
  },
  {
    "State": "TX",
    "County": "Hardin",
    "NumberofStores": 163
  },
  {
    "State": "TX",
    "County": "Harris",
    "NumberofStores": 3275
  },
  {
    "State": "TX",
    "County": "Harrison",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Hartley",
    "NumberofStores": 13
  },
  {
    "State": "TX",
    "County": "Hays",
    "NumberofStores": 347
  },
  {
    "State": "TX",
    "County": "Hemphill",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Henderson",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Hidalgo",
    "NumberofStores": 983
  },
  {
    "State": "TX",
    "County": "Hill",
    "NumberofStores": 137
  },
  {
    "State": "TX",
    "County": "Hockley",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Hood",
    "NumberofStores": 127
  },
  {
    "State": "TX",
    "County": "Hopkins",
    "NumberofStores": 167
  },
  {
    "State": "TX",
    "County": "Howard",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Hunt",
    "NumberofStores": 213
  },
  {
    "State": "TX",
    "County": "Hutchinson",
    "NumberofStores": 79
  },
  {
    "State": "TX",
    "County": "Irion",
    "NumberofStores": 7
  },
  {
    "State": "TX",
    "County": "Jack",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Jackson",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Jasper",
    "NumberofStores": 137
  },
  {
    "State": "TX",
    "County": "Jeff Davis",
    "NumberofStores": 9
  },
  {
    "State": "TX",
    "County": "Jefferson",
    "NumberofStores": 347
  },
  {
    "State": "TX",
    "County": "Jim Wells",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Johnson",
    "NumberofStores": 287
  },
  {
    "State": "TX",
    "County": "Karnes",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "Kaufman",
    "NumberofStores": 213
  },
  {
    "State": "TX",
    "County": "Kendall",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Kenedy",
    "NumberofStores": 5
  },
  {
    "State": "TX",
    "County": "Kent",
    "NumberofStores": 3
  },
  {
    "State": "TX",
    "County": "King",
    "NumberofStores": 1
  },
  {
    "State": "TX",
    "County": "Kinney",
    "NumberofStores": 17
  },
  {
    "State": "TX",
    "County": "Kleberg",
    "NumberofStores": 113
  },
  {
    "State": "TX",
    "County": "Knox",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Lamar",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Lamb",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Lampasas",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Lavaca",
    "NumberofStores": 89
  },
  {
    "State": "TX",
    "County": "Lee",
    "NumberofStores": 73
  },
  {
    "State": "TX",
    "County": "Leon",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Liberty",
    "NumberofStores": 127
  },
  {
    "State": "TX",
    "County": "Limestone",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Lipscomb",
    "NumberofStores": 19
  },
  {
    "State": "TX",
    "County": "Live Oak",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "Loving",
    "NumberofStores": 1
  },
  {
    "State": "TX",
    "County": "Lubbock",
    "NumberofStores": 497
  },
  {
    "State": "TX",
    "County": "Lynn",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Madison",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Marion",
    "NumberofStores": 47
  },
  {
    "State": "TX",
    "County": "Martin",
    "NumberofStores": 23
  },
  {
    "State": "TX",
    "County": "Matagorda",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Maverick",
    "NumberofStores": 163
  },
  {
    "State": "TX",
    "County": "McLennan",
    "NumberofStores": 317
  },
  {
    "State": "TX",
    "County": "McMullen",
    "NumberofStores": 3
  },
  {
    "State": "TX",
    "County": "Medina",
    "NumberofStores": 131
  },
  {
    "State": "TX",
    "County": "Midland",
    "NumberofStores": 293
  },
  {
    "State": "TX",
    "County": "Milam",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Mills",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Mitchell",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "Montague",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Montgomery",
    "NumberofStores": 1139
  },
  {
    "State": "TX",
    "County": "Moore",
    "NumberofStores": 163
  },
  {
    "State": "TX",
    "County": "Morris",
    "NumberofStores": 47
  },
  {
    "State": "TX",
    "County": "Motley",
    "NumberofStores": 9
  },
  {
    "State": "TX",
    "County": "Nacogdoches",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Navarro",
    "NumberofStores": 187
  },
  {
    "State": "TX",
    "County": "Newton",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Nueces",
    "NumberofStores": 421
  },
  {
    "State": "TX",
    "County": "Ochiltree",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Oldham",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Orange",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Palo Pinto",
    "NumberofStores": 79
  },
  {
    "State": "TX",
    "County": "Panola",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Parker",
    "NumberofStores": 317
  },
  {
    "State": "TX",
    "County": "Pecos",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Polk",
    "NumberofStores": 163
  },
  {
    "State": "TX",
    "County": "Potter",
    "NumberofStores": 293
  },
  {
    "State": "TX",
    "County": "Presidio",
    "NumberofStores": 17
  },
  {
    "State": "TX",
    "County": "Randall",
    "NumberofStores": 347
  },
  {
    "State": "TX",
    "County": "Reagan",
    "NumberofStores": 13
  },
  {
    "State": "TX",
    "County": "Real",
    "NumberofStores": 23
  },
  {
    "State": "TX",
    "County": "Red River",
    "NumberofStores": 73
  },
  {
    "State": "TX",
    "County": "Reeves",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Refugio",
    "NumberofStores": 47
  },
  {
    "State": "TX",
    "County": "Roberts",
    "NumberofStores": 7
  },
  {
    "State": "TX",
    "County": "Robertson",
    "NumberofStores": 113
  },
  {
    "State": "TX",
    "County": "Rockwall",
    "NumberofStores": 263
  },
  {
    "State": "TX",
    "County": "Runnels",
    "NumberofStores": 39
  },
  {
    "State": "TX",
    "County": "Rusk",
    "NumberofStores": 143
  },
  {
    "State": "TX",
    "County": "Sabine",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "San Augustine",
    "NumberofStores": 37
  },
  {
    "State": "TX",
    "County": "San Jacinto",
    "NumberofStores": 59
  },
  {
    "State": "TX",
    "County": "San Patricio",
    "NumberofStores": 167
  },
  {
    "State": "TX",
    "County": "San Saba",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Schleicher",
    "NumberofStores": 19
  },
  {
    "State": "TX",
    "County": "Scurry",
    "NumberofStores": 67
  },
  {
    "State": "TX",
    "County": "Shackelford",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Shelby",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Sherman",
    "NumberofStores": 13
  },
  {
    "State": "TX",
    "County": "Somervell",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Starr",
    "NumberofStores": 487
  },
  {
    "State": "TX",
    "County": "Stephens",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Sterling",
    "NumberofStores": 11
  },
  {
    "State": "TX",
    "County": "Sutton",
    "NumberofStores": 23
  },
  {
    "State": "TX",
    "County": "Swisher",
    "NumberofStores": 41
  },
  {
    "State": "TX",
    "County": "Tarrant",
    "NumberofStores": 1189
  },
  {
    "State": "TX",
    "County": "Terrell",
    "NumberofStores": 19
  },
  {
    "State": "TX",
    "County": "Terry",
    "NumberofStores": 53
  },
  {
    "State": "TX",
    "County": "Throckmorton",
    "NumberofStores": 7
  },
  {
    "State": "TX",
    "County": "Titus",
    "NumberofStores": 137
  },
  {
    "State": "TX",
    "County": "Tom Green",
    "NumberofStores": 263
  },
  {
    "State": "TX",
    "County": "Travis",
    "NumberofStores": 913
  },
  {
    "State": "TX",
    "County": "Trinity",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Tyler",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Upshur",
    "NumberofStores": 127
  },
  {
    "State": "TX",
    "County": "Upton",
    "NumberofStores": 13
  },
  {
    "State": "TX",
    "County": "Uvalde",
    "NumberofStores": 89
  },
  {
    "State": "TX",
    "County": "Val Verde",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Van Zandt",
    "NumberofStores": 163
  },
  {
    "State": "TX",
    "County": "Victoria",
    "NumberofStores": 168
  },
  {
    "State": "TX",
    "County": "Walker",
    "NumberofStores": 173
  },
  {
    "State": "TX",
    "County": "Waller",
    "NumberofStores": 137
  },
  {
    "State": "TX",
    "County": "Ward",
    "NumberofStores": 29
  },
  {
    "State": "TX",
    "County": "Washington",
    "NumberofStores": 97
  },
  {
    "State": "TX",
    "County": "Wharton",
    "NumberofStores": 113
  },
  {
    "State": "TX",
    "County": "Wheeler",
    "NumberofStores": 23
  },
  {
    "State": "TX",
    "County": "Wichita",
    "NumberofStores": 197
  },
  {
    "State": "TX",
    "County": "Wilbarger",
    "NumberofStores": 61
  },
  {
    "State": "TX",
    "County": "Willacy",
    "NumberofStores": 83
  },
  {
    "State": "TX",
    "County": "Williamson",
    "NumberofStores": 347
  },
  {
    "State": "TX",
    "County": "Wilson",
    "NumberofStores": 127
  },
  {
    "State": "TX",
    "County": "Winkler",
    "NumberofStores": 19
  },
  {
    "State": "TX",
    "County": "Wise",
    "NumberofStores": 137
  },
  {
    "State": "TX",
    "County": "Young",
    "NumberofStores": 73
  },
  {
    "State": "TX",
    "County": "Zavala",
    "NumberofStores": 41
  },
  {
    "State": "VA",
    "County": "Bristol city",
    "NumberofStores": 53
  },
  {
    "State": "VA",
    "County": "Buchanan",
    "NumberofStores": 29
  },
  {
    "State": "VA",
    "County": "Dickenson",
    "NumberofStores": 37
  },
  {
    "State": "VA",
    "County": "Lee",
    "NumberofStores": 47
  },
  {
    "State": "VA",
    "County": "Norton city",
    "NumberofStores": 23
  },
  {
    "State": "VA",
    "County": "Russell",
    "NumberofStores": 61
  },
  {
    "State": "VA",
    "County": "Scott",
    "NumberofStores": 43
  },
  {
    "State": "VA",
    "County": "Washington",
    "NumberofStores": 83
  },
  {
    "State": "VA",
    "County": "Wise",
    "NumberofStores": 97
  },
  {
    "State": "WA",
    "County": "Benton",
    "NumberofStores": 213
  },
  {
    "State": "WA",
    "County": "Franklin",
    "NumberofStores": 127
  },
  {
    "State": "WA",
    "County": "Lincoln",
    "NumberofStores": 41
  },
  {
    "State": "WA",
    "County": "Pend Oreille",
    "NumberofStores": 29
  },
  {
    "State": "WA",
    "County": "Spokane",
    "NumberofStores": 173
  },
  {
    "State": "WA",
    "County": "Stevens",
    "NumberofStores": 47
  },
  {
    "State": "WA",
    "County": "Whitman",
    "NumberofStores": 73
  },
  {
    "State": "WI",
    "County": "Adams",
    "NumberofStores": 19
  },
  {
    "State": "WI",
    "County": "Ashland",
    "NumberofStores": 31
  },
  {
    "State": "WI",
    "County": "Bayfield",
    "NumberofStores": 11
  },
  {
    "State": "WI",
    "County": "Calumet",
    "NumberofStores": 113
  },
  {
    "State": "WI",
    "County": "Columbia",
    "NumberofStores": 39
  },
  {
    "State": "WI",
    "County": "Crawford",
    "NumberofStores": 53
  },
  {
    "State": "WI",
    "County": "Dane",
    "NumberofStores": 83
  },
  {
    "State": "WI",
    "County": "Dodge",
    "NumberofStores": 97
  },
  {
    "State": "WI",
    "County": "Douglas",
    "NumberofStores": 41
  },
  {
    "State": "WI",
    "County": "Fond du Lac",
    "NumberofStores": 127
  },
  {
    "State": "WI",
    "County": "Grant",
    "NumberofStores": 61
  },
  {
    "State": "WI",
    "County": "Green",
    "NumberofStores": 29
  },
  {
    "State": "WI",
    "County": "Green Lake",
    "NumberofStores": 173
  },
  {
    "State": "WI",
    "County": "Iowa",
    "NumberofStores": 83
  },
  {
    "State": "WI",
    "County": "Jackson",
    "NumberofStores": 47
  },
  {
    "State": "WI",
    "County": "Jefferson",
    "NumberofStores": 97
  },
  {
    "State": "WI",
    "County": "Juneau",
    "NumberofStores": 213
  },
  {
    "State": "WI",
    "County": "Kenosha",
    "NumberofStores": 61
  },
  {
    "State": "WI",
    "County": "La Crosse",
    "NumberofStores": 41
  },
  {
    "State": "WI",
    "County": "Lafayette",
    "NumberofStores": 137
  },
  {
    "State": "WI",
    "County": "Manitowoc",
    "NumberofStores": 29
  },
  {
    "State": "WI",
    "County": "Marquette",
    "NumberofStores": 83
  },
  {
    "State": "WI",
    "County": "Milwaukee",
    "NumberofStores": 47
  },
  {
    "State": "WI",
    "County": "Monroe",
    "NumberofStores": 173
  },
  {
    "State": "WI",
    "County": "Outagamie",
    "NumberofStores": 61
  },
  {
    "State": "WI",
    "County": "Ozaukee",
    "NumberofStores": 31
  },
  {
    "State": "WI",
    "County": "Portage",
    "NumberofStores": 113
  },
  {
    "State": "WI",
    "County": "Racine",
    "NumberofStores": 173
  },
  {
    "State": "WI",
    "County": "Richland",
    "NumberofStores": 41
  },
  {
    "State": "WI",
    "County": "Rock",
    "NumberofStores": 137
  },
  {
    "State": "WI",
    "County": "Sauk",
    "NumberofStores": 113
  },
  {
    "State": "WI",
    "County": "Sheboygan",
    "NumberofStores": 197
  },
  {
    "State": "WI",
    "County": "Vernon",
    "NumberofStores": 53
  },
  {
    "State": "WI",
    "County": "Walworth",
    "NumberofStores": 163
  },
  {
    "State": "WI",
    "County": "Washington",
    "NumberofStores": 127
  },
  {
    "State": "WI",
    "County": "Waukesha",
    "NumberofStores": 347
  },
  {
    "State": "WI",
    "County": "Waupaca",
    "NumberofStores": 83
  },
  {
    "State": "WI",
    "County": "Waushara",
    "NumberofStores": 61
  },
  {
    "State": "WI",
    "County": "Winnebago",
    "NumberofStores": 213
  },
  {
    "State": "WI",
    "County": "Wood",
    "NumberofStores": 47
  },
  {
    "State": "WV",
    "County": "Barbour",
    "NumberofStores": 37
  },
  {
    "State": "WV",
    "County": "Boone",
    "NumberofStores": 97
  },
  {
    "State": "WV",
    "County": "Braxton",
    "NumberofStores": 61
  },
  {
    "State": "WV",
    "County": "Brooke",
    "NumberofStores": 73
  },
  {
    "State": "WV",
    "County": "Cabell",
    "NumberofStores": 173
  },
  {
    "State": "WV",
    "County": "Calhoun",
    "NumberofStores": 29
  },
  {
    "State": "WV",
    "County": "Clay",
    "NumberofStores": 47
  },
  {
    "State": "WV",
    "County": "Doddridge",
    "NumberofStores": 19
  },
  {
    "State": "WV",
    "County": "Fayette",
    "NumberofStores": 41
  },
  {
    "State": "WV",
    "County": "Gilmer",
    "NumberofStores": 83
  },
  {
    "State": "WV",
    "County": "Greenbrier",
    "NumberofStores": 29
  },
  {
    "State": "WV",
    "County": "Hancock",
    "NumberofStores": 137
  },
  {
    "State": "WV",
    "County": "Harrison",
    "NumberofStores": 31
  },
  {
    "State": "WV",
    "County": "Jackson",
    "NumberofStores": 163
  },
  {
    "State": "WV",
    "County": "Kanawha",
    "NumberofStores": 53
  },
  {
    "State": "WV",
    "County": "Lewis",
    "NumberofStores": 173
  },
  {
    "State": "WV",
    "County": "Lincoln",
    "NumberofStores": 97
  },
  {
    "State": "WV",
    "County": "Logan",
    "NumberofStores": 61
  },
  {
    "State": "WV",
    "County": "Marion",
    "NumberofStores": 41
  },
  {
    "State": "WV",
    "County": "Marshall",
    "NumberofStores": 113
  },
  {
    "State": "WV",
    "County": "Mason",
    "NumberofStores": 73
  },
  {
    "State": "WV",
    "County": "McDowell",
    "NumberofStores": 19
  },
  {
    "State": "WV",
    "County": "Mercer",
    "NumberofStores": 47
  },
  {
    "State": "WV",
    "County": "Mingo",
    "NumberofStores": 173
  },
  {
    "State": "WV",
    "County": "Monongalia",
    "NumberofStores": 83
  },
  {
    "State": "WV",
    "County": "Monroe",
    "NumberofStores": 29
  },
  {
    "State": "WV",
    "County": "Nicholas",
    "NumberofStores": 97
  },
  {
    "State": "WV",
    "County": "Ohio",
    "NumberofStores": 41
  },
  {
    "State": "WV",
    "County": "Pleasants",
    "NumberofStores": 163
  },
  {
    "State": "WV",
    "County": "Pocahontas",
    "NumberofStores": 113
  },
  {
    "State": "WV",
    "County": "Preston",
    "NumberofStores": 47
  },
  {
    "State": "WV",
    "County": "Putnam",
    "NumberofStores": 61
  },
  {
    "State": "WV",
    "County": "Raleigh",
    "NumberofStores": 29
  },
  {
    "State": "WV",
    "County": "Randolph",
    "NumberofStores": 137
  },
  {
    "State": "WV",
    "County": "Ritchie",
    "NumberofStores": 19
  },
  {
    "State": "WV",
    "County": "Roane",
    "NumberofStores": 173
  },
  {
    "State": "WV",
    "County": "Summers",
    "NumberofStores": 53
  },
  {
    "State": "WV",
    "County": "Taylor",
    "NumberofStores": 83
  },
  {
    "State": "WV",
    "County": "Tyler",
    "NumberofStores": 29
  },
  {
    "State": "WV",
    "County": "Upshur",
    "NumberofStores": 213
  },
  {
    "State": "WV",
    "County": "Washington County",
    "NumberofStores": 53
  },
  {
    "State": "WV",
    "County": "Wayne",
    "NumberofStores": 97
  },
  {
    "State": "WV",
    "County": "Webster",
    "NumberofStores": 41
  },
  {
    "State": "WV",
    "County": "Wetzel",
    "NumberofStores": 61
  },
  {
    "State": "WV",
    "County": "Wirt",
    "NumberofStores": 29
  },
  {
    "State": "WV",
    "County": "Wood",
    "NumberofStores": 173
  },
  {
    "State": "WV",
    "County": "Wyoming",
    "NumberofStores": 83
  }
]
export default Datamap;